var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _g, _path625, _path626, _path627, _path628, _path629, _g2, _path630, _g3, _g4, _path631, _path632, _path633, _g5, _path634, _path635, _path636, _path637, _path638, _path639, _g6, _path640, _path641, _path642, _path643, _g7, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _g8, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _g9, _path670, _path671, _path672, _g0, _path673, _path674, _path675;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyDetailsCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 144,
    viewBox: "0 0 218 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3666 38.0723H19.302V88.5172H35.3666V38.0723Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3665 38.0723H27.3342V88.3784H35.3665V38.0723Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8092 33.1201H21.1362V38.0723H26.8092V33.1201Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8092 33.1201H25.457V38.0723H26.8092V33.1201Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9631 38.0721V37.7832H35.8368V38.0721",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 40.2324H22.4731V43.0733H23.8329V40.2324Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3343 44.1879C27.3343 44.2179 25.5359 44.2421 23.3184 44.2421C21.1001 44.2421 19.302 44.2179 19.302 44.1879C19.302 44.158 21.0998 44.1338 23.3184 44.1338C25.5362 44.1335 27.3343 44.158 27.3343 44.1879Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 40.2324H30.5752V43.0733H31.9349V40.2324Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 44.1879C35.4366 44.2179 33.6382 44.2421 31.4207 44.2421C29.2021 44.2421 27.4043 44.2179 27.4043 44.1879C27.4043 44.158 29.2021 44.1338 31.4207 44.1338C33.6382 44.1335 35.4366 44.158 35.4366 44.1879Z",
    fill: "#E0E0E0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 45.873H30.5752V48.7139H31.9349V45.873Z",
    fill: "#E0E0E0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 49.8286C35.4366 49.8585 33.6382 49.8827 31.4207 49.8827C29.2021 49.8827 27.4043 49.8582 27.4043 49.8286C27.4043 49.7986 29.2021 49.7744 31.4207 49.7744C33.6382 49.7744 35.4366 49.7986 35.4366 49.8286Z",
    fill: "#E0E0E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 51.6836H30.5752V54.5244H31.9349V51.6836Z",
    fill: "#E0E0E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 55.6391C35.4366 55.6691 33.6382 55.6932 31.4207 55.6932C29.2021 55.6932 27.4043 55.6691 27.4043 55.6391C27.4043 55.6091 29.2021 55.585 31.4207 55.585C33.6382 55.585 35.4366 55.6091 35.4366 55.6391Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 57.4932H30.5752V60.334H31.9349V57.4932Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 61.4487C35.4366 61.4786 33.6382 61.5028 31.4207 61.5028C29.2021 61.5028 27.4043 61.4786 27.4043 61.4487C27.4043 61.4187 29.2021 61.3945 31.4207 61.3945C33.6382 61.3945 35.4366 61.4187 35.4366 61.4487Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 63.1377H30.5752V65.9785H31.9349V63.1377Z",
    fill: "#E0E0E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 67.0932C35.4366 67.1232 33.6382 67.1474 31.4207 67.1474C29.2021 67.1474 27.4043 67.1232 27.4043 67.0932C27.4043 67.0633 29.2021 67.0391 31.4207 67.0391C33.6382 67.0388 35.4366 67.0633 35.4366 67.0932Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 68.8047H30.5752V71.6458H31.9349V68.8047Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9349 74.5459H30.5752V77.3867H31.9349V74.5459Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4366 72.7612C35.4366 72.7911 33.6382 72.8153 31.4207 72.8153C29.2021 72.8153 27.4043 72.7908 27.4043 72.7612C27.4043 72.7312 29.2021 72.707 31.4207 72.707C33.6382 72.7067 35.4366 72.7309 35.4366 72.7612Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 45.959H22.4731V48.7998H23.8329V45.959Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3343 49.9145C27.3343 49.9444 25.5359 49.9686 23.3184 49.9686C21.1001 49.9686 19.302 49.9444 19.302 49.9145C19.302 49.8845 21.0998 49.8604 23.3184 49.8604C25.5362 49.8604 27.3343 49.8845 27.3343 49.9145Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 51.6855H22.4731V54.5264H23.8329V51.6855Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3343 55.6411C27.3343 55.671 25.5359 55.6952 23.3184 55.6952C21.1001 55.6952 19.302 55.671 19.302 55.6411C19.302 55.6111 21.0998 55.5869 23.3184 55.5869C25.5362 55.5866 27.3343 55.6111 27.3343 55.6411Z",
    fill: "#E0E0E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 57.4111H22.4731V60.252H23.8329V57.4111Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3343 61.3676C27.3343 61.3976 25.5359 61.4218 23.3184 61.4218C21.1001 61.4218 19.302 61.3976 19.302 61.3676C19.302 61.3377 21.0998 61.3135 23.3184 61.3135C25.5362 61.3135 27.3343 61.3377 27.3343 61.3676Z",
    fill: "#E0E0E0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 63.1377H22.4731V65.9785H23.8329V63.1377Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3343 67.0942C27.3343 67.1241 25.5359 67.1483 23.3184 67.1483C21.1001 67.1483 19.302 67.1241 19.302 67.0942C19.302 67.0642 21.0998 67.04 23.3184 67.04C25.5362 67.0398 27.3343 67.0642 27.3343 67.0942Z",
    fill: "#E0E0E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 68.8643H22.4731V71.7051H23.8329V68.8643Z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3343 72.8207C27.3343 72.8507 25.5359 72.8749 23.3184 72.8749C21.1001 72.8749 19.302 72.8507 19.302 72.8207C19.302 72.7908 21.0998 72.7666 23.3184 72.7666C25.5362 72.7666 27.3343 72.7908 27.3343 72.8207Z",
    fill: "#E0E0E0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8329 74.5908H22.4731V77.4316H23.8329V74.5908Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4804 52.377H7.93799V88.6223H19.4804V52.377Z",
    fill: "#F5F5F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4804 52.377H13.7092V88.5224H19.4804V52.377Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3319 48.8184H9.25586V52.3766H13.3319V48.8184Z",
    fill: "#F5F5F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3318 48.8184H12.3604V52.3766H13.3318V48.8184Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97583 52.3763V52.1689H19.8181V52.3763",
    fill: "#E0E0E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 53.9287H10.2161V55.9701H11.193V53.9287Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7092 56.7713C13.7092 56.7929 12.4172 56.8102 10.8235 56.8102C9.22947 56.8102 7.93774 56.7926 7.93774 56.7713C7.93774 56.7497 9.22947 56.7324 10.8235 56.7324C12.4172 56.7324 13.7092 56.75 13.7092 56.7713Z",
    fill: "#E0E0E0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 53.9287H16.0378V55.9701H17.0148V53.9287Z",
    fill: "#E0E0E0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5307 56.7713C19.5307 56.7929 18.2387 56.8102 16.6453 56.8102C15.0512 56.8102 13.7595 56.7926 13.7595 56.7713C13.7595 56.7497 15.0512 56.7324 16.6453 56.7324C18.2387 56.7324 19.5307 56.75 19.5307 56.7713Z",
    fill: "#E0E0E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 57.9814H16.0378V60.0228H17.0148V57.9814Z",
    fill: "#E0E0E0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5307 60.824C19.5307 60.8456 18.2387 60.8629 16.6453 60.8629C15.0512 60.8629 13.7595 60.8453 13.7595 60.824C13.7595 60.8024 15.0512 60.7852 16.6453 60.7852C18.2387 60.7852 19.5307 60.8024 19.5307 60.824Z",
    fill: "#E0E0E0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 62.1562H16.0378V64.1976H17.0148V62.1562Z",
    fill: "#E0E0E0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5307 64.9988C19.5307 65.0204 18.2387 65.0377 16.6453 65.0377C15.0512 65.0377 13.7595 65.0202 13.7595 64.9988C13.7595 64.9772 15.0512 64.96 16.6453 64.96C18.2387 64.9597 19.5307 64.9772 19.5307 64.9988Z",
    fill: "#E0E0E0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 66.3311H16.0378V68.3724H17.0148V66.3311Z",
    fill: "#E0E0E0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5307 69.1736C19.5307 69.1952 18.2387 69.2128 16.6453 69.2128C15.0512 69.2128 13.7595 69.1952 13.7595 69.1736C13.7595 69.1523 15.0512 69.1348 16.6453 69.1348C18.2387 69.1348 19.5307 69.152 19.5307 69.1736Z",
    fill: "#E0E0E0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 70.3867H16.0378V72.4281H17.0148V70.3867Z",
    fill: "#E0E0E0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5307 73.2293C19.5307 73.2509 18.2387 73.2685 16.6453 73.2685C15.0512 73.2685 13.7595 73.2509 13.7595 73.2293C13.7595 73.208 15.0512 73.1904 16.6453 73.1904C18.2387 73.1901 19.5307 73.2077 19.5307 73.2293Z",
    fill: "#E0E0E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 74.459H16.0378V76.5003H17.0148V74.459Z",
    fill: "#E0E0E0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0148 78.584H16.0378V80.6253H17.0148V78.584Z",
    fill: "#E0E0E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5307 77.3016C19.5307 77.3232 18.2387 77.3405 16.6453 77.3405C15.0512 77.3405 13.7595 77.3229 13.7595 77.3016C13.7595 77.28 15.0512 77.2627 16.6453 77.2627C18.2387 77.2627 19.5307 77.2803 19.5307 77.3016Z",
    fill: "#E0E0E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 58.043H10.2161V60.0843H11.193V58.043Z",
    fill: "#FAFAFA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7092 60.8856C13.7092 60.9072 12.4172 60.9244 10.8235 60.9244C9.22947 60.9244 7.93774 60.9072 7.93774 60.8856C7.93774 60.864 9.22947 60.8467 10.8235 60.8467C12.4172 60.8467 13.7092 60.864 13.7092 60.8856Z",
    fill: "#E0E0E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 62.1572H10.2161V64.1986H11.193V62.1572Z",
    fill: "#FAFAFA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7092 64.9998C13.7092 65.0214 12.4172 65.0387 10.8235 65.0387C9.22947 65.0387 7.93774 65.0214 7.93774 64.9998C7.93774 64.9782 9.22947 64.9609 10.8235 64.9609C12.4172 64.9607 13.7092 64.9782 13.7092 64.9998Z",
    fill: "#E0E0E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 66.2725H10.2161V68.3138H11.193V66.2725Z",
    fill: "#FAFAFA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7092 69.1151C13.7092 69.1367 12.4172 69.1539 10.8235 69.1539C9.22947 69.1539 7.93774 69.1367 7.93774 69.1151C7.93774 69.0935 9.22947 69.0762 10.8235 69.0762C12.4172 69.0762 13.7092 69.0937 13.7092 69.1151Z",
    fill: "#E0E0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 70.3867H10.2161V72.4281H11.193V70.3867Z",
    fill: "#FAFAFA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7092 73.2293C13.7092 73.2509 12.4172 73.2685 10.8235 73.2685C9.22947 73.2685 7.93774 73.2509 7.93774 73.2293C7.93774 73.208 9.22947 73.1904 10.8235 73.1904C12.4172 73.1901 13.7092 73.2077 13.7092 73.2293Z",
    fill: "#E0E0E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 74.501H10.2161V76.5423H11.193V74.501Z",
    fill: "#FAFAFA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7092 77.3436C13.7092 77.3652 12.4172 77.3824 10.8235 77.3824C9.22947 77.3824 7.93774 77.3649 7.93774 77.3436C7.93774 77.322 9.22947 77.3047 10.8235 77.3047C12.4172 77.3047 13.7092 77.3222 13.7092 77.3436Z",
    fill: "#E0E0E0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.193 78.6152H10.2161V80.6566H11.193V78.6152Z",
    fill: "#FAFAFA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4599 20.3389H72.3022V54.5723H85.4599V20.3389Z",
    fill: "#EBEBEB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4601 20.3389H78.8811V54.5723H85.4601V20.3389Z",
    fill: "#E0E0E0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M78.451 16.2695H73.8047V20.339H78.451V16.2695Z",
    fill: "#EBEBEB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4509 16.2695H77.3435V20.339H78.4509V16.2695Z",
    fill: "#E0E0E0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8452 20.1016H71.2058V20.3389H85.8452V20.1016Z",
    fill: "#E0E0E0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 22.1133H74.8997V24.4475H76.0135V22.1133Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8812 25.364C78.8812 25.3887 77.4083 25.4086 75.592 25.4086C73.775 25.4086 72.3025 25.3887 72.3025 25.364C72.3025 25.3395 73.775 25.3193 75.592 25.3193C77.4083 25.3196 78.8812 25.3395 78.8812 25.364Z",
    fill: "#E0E0E0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 22.1133H81.5356V24.4475H82.6495V22.1133Z",
    fill: "#F5F5F5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5172 25.364C85.5172 25.3887 84.0444 25.4086 82.228 25.4086C80.4108 25.4086 78.9382 25.3887 78.9382 25.364C78.9382 25.3395 80.4108 25.3193 82.228 25.3193C84.0444 25.3196 85.5172 25.3395 85.5172 25.364Z",
    fill: "#EBEBEB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 26.748H81.5356V29.0823H82.6495V26.748Z",
    fill: "#F5F5F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5172 29.9987C85.5172 30.0235 84.0444 30.0434 82.228 30.0434C80.4108 30.0434 78.9382 30.0235 78.9382 29.9987C78.9382 29.974 80.4108 29.9541 82.228 29.9541C84.0444 29.9541 85.5172 29.974 85.5172 29.9987Z",
    fill: "#EBEBEB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 31.5225H81.5356V33.857H82.6495V31.5225Z",
    fill: "#F5F5F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5172 34.7732C85.5172 34.7976 84.0444 34.8178 82.228 34.8178C80.4108 34.8178 78.9382 34.7979 78.9382 34.7732C78.9382 34.7484 80.4108 34.7285 82.228 34.7285C84.0444 34.7285 85.5172 34.7484 85.5172 34.7732Z",
    fill: "#EBEBEB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 36.2969H81.5356V38.6311H82.6495V36.2969Z",
    fill: "#F5F5F5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5172 39.5476C85.5172 39.572 84.0444 39.5922 82.228 39.5922C80.4108 39.5922 78.9382 39.5723 78.9382 39.5476C78.9382 39.5231 80.4108 39.5029 82.228 39.5029C84.0444 39.5032 85.5172 39.5231 85.5172 39.5476Z",
    fill: "#EBEBEB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 40.9346H81.5356V43.2688H82.6495V40.9346Z",
    fill: "#F5F5F5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5172 44.1853C85.5172 44.2097 84.0444 44.2299 82.228 44.2299C80.4108 44.2299 78.9382 44.21 78.9382 44.1853C78.9382 44.1608 80.4108 44.1406 82.228 44.1406C84.0444 44.1406 85.5172 44.1608 85.5172 44.1853Z",
    fill: "#EBEBEB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 45.5918H81.5356V47.926H82.6495V45.5918Z",
    fill: "#F5F5F5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6495 50.3096H81.5356V52.6438H82.6495V50.3096Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5172 48.8425C85.5172 48.867 84.0444 48.8871 82.228 48.8871C80.4108 48.8871 78.9382 48.867 78.9382 48.8425C78.9382 48.818 80.4108 48.7979 82.228 48.7979C84.0444 48.7979 85.5172 48.8177 85.5172 48.8425Z",
    fill: "#EBEBEB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 26.8193H74.8997V29.1536H76.0135V26.8193Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8812 30.0691C78.8812 30.0938 77.4083 30.1137 75.592 30.1137C73.775 30.1137 72.3025 30.0938 72.3025 30.0691C72.3025 30.0446 73.775 30.0244 75.592 30.0244C77.4083 30.0247 78.8812 30.0446 78.8812 30.0691Z",
    fill: "#E0E0E0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 31.5244H74.8997V33.8587H76.0135V31.5244Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8812 34.7751C78.8812 34.7996 77.4083 34.8197 75.592 34.8197C73.775 34.8197 72.3025 34.7999 72.3025 34.7751C72.3025 34.7503 73.775 34.7305 75.592 34.7305C77.4083 34.7305 78.8812 34.7506 78.8812 34.7751Z",
    fill: "#E0E0E0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 36.2295H74.8997V38.5637H76.0135V36.2295Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8812 39.4802C78.8812 39.505 77.4083 39.5248 75.592 39.5248C73.775 39.5248 72.3025 39.505 72.3025 39.4802C72.3025 39.4554 73.775 39.4355 75.592 39.4355C77.4083 39.4358 78.8812 39.4557 78.8812 39.4802Z",
    fill: "#E0E0E0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 40.9346H74.8997V43.2688H76.0135V40.9346Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8812 44.1853C78.8812 44.2097 77.4083 44.2299 75.592 44.2299C73.775 44.2299 72.3025 44.21 72.3025 44.1853C72.3025 44.1608 73.775 44.1406 75.592 44.1406C77.4083 44.1406 78.8812 44.1608 78.8812 44.1853Z",
    fill: "#E0E0E0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 45.6406H74.8997V47.9749H76.0135V45.6406Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8812 48.8903C78.8812 48.9151 77.4083 48.935 75.592 48.935C73.775 48.935 72.3025 48.9151 72.3025 48.8903C72.3025 48.8659 73.775 48.8457 75.592 48.8457C77.4083 48.8457 78.8812 48.8659 78.8812 48.8903Z",
    fill: "#E0E0E0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0135 50.3457H74.8997V52.6799H76.0135V50.3457Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0165 59.0791H38.481V88.3866H54.0165V59.0791Z",
    fill: "#E0E0E0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0165 59.0791H46.7324V88.3866H54.0165V59.0791Z",
    fill: "#EBEBEB"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1355 61.8369H41.7385V65.2103H43.1355V61.8369Z",
    fill: "#F5F5F5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1355 75.04H41.7385V78.4134H43.1355V75.04Z",
    fill: "#F5F5F5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7324 66.5341C46.7324 66.5632 44.8849 66.5869 42.6069 66.5869C40.3278 66.5869 38.4812 66.5632 38.4812 66.5341C38.4812 66.5051 40.3281 66.4814 42.6069 66.4814C44.8849 66.4817 46.7324 66.5051 46.7324 66.5341Z",
    fill: "#F5F5F5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1355 68.4883H41.7385V71.8616H43.1355V68.4883Z",
    fill: "#F5F5F5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7324 73.1852C46.7324 73.2143 44.8849 73.2379 42.6069 73.2379C40.3278 73.2379 38.4812 73.2146 38.4812 73.1852C38.4812 73.1561 40.3281 73.1328 42.6069 73.1328C44.8849 73.1328 46.7324 73.1564 46.7324 73.1852Z",
    fill: "#F5F5F5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6762 61.8369H48.2793V65.2103H49.6762V61.8369Z",
    fill: "#E0E0E0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7065 61.8369H51.3096V65.2103H52.7065V61.8369Z",
    fill: "#E0E0E0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6762 68.2383H48.2793V71.6116H49.6762V68.2383Z",
    fill: "#E0E0E0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7065 68.2383H51.3096V71.6116H52.7065V68.2383Z",
    fill: "#E0E0E0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6762 74.6387H48.2793V78.012H49.6762V74.6387Z",
    fill: "#E0E0E0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7065 74.6387H51.3096V78.012H52.7065V74.6387Z",
    fill: "#E0E0E0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1843 58.3701H37.313V59.1045H55.1843V58.3701Z",
    fill: "#E0E0E0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1252 59.1735C54.1252 59.2026 50.6529 59.2262 46.3705 59.2262C42.0867 59.2262 38.6152 59.2026 38.6152 59.1735C38.6152 59.1444 42.087 59.1211 46.3705 59.1211C50.6529 59.1211 54.1252 59.1447 54.1252 59.1735Z",
    fill: "#EBEBEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M112.304 37.9668H99.0198V79.8132H112.304V37.9668Z",
    fill: "#F5F5F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M112.303 37.9668H105.662V79.698H112.303V37.9668Z",
    fill: "#EBEBEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M105.227 33.8584H100.537V37.9667H105.227V33.8584Z",
    fill: "#F5F5F5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M105.228 33.8584H104.11V37.9667H105.228V33.8584Z",
    fill: "#EBEBEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9128 37.9672V37.7275H112.692V37.9672",
    fill: "#E0E0E0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 39.7588H101.642V42.1155H102.766V39.7588Z",
    fill: "#FAFAFA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 43.04C105.662 43.0651 104.175 43.085 102.341 43.085C100.507 43.085 99.0198 43.0648 99.0198 43.04C99.0198 43.0153 100.507 42.9951 102.341 42.9951C104.175 42.9951 105.662 43.0153 105.662 43.04Z",
    fill: "#E0E0E0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 39.7588H108.342V42.1155H109.466V39.7588Z",
    fill: "#E0E0E0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 43.04C112.361 43.0651 110.874 43.085 109.04 43.085C107.206 43.085 105.719 43.0648 105.719 43.04C105.719 43.0153 107.206 42.9951 109.04 42.9951C110.874 42.9951 112.361 43.0153 112.361 43.04Z",
    fill: "#E0E0E0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 44.4375H108.342V46.7942H109.466V44.4375Z",
    fill: "#E0E0E0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 47.7188C112.361 47.7435 110.874 47.7637 109.04 47.7637C107.206 47.7637 105.719 47.7435 105.719 47.7188C105.719 47.694 107.206 47.6738 109.04 47.6738C110.874 47.6738 112.361 47.694 112.361 47.7188Z",
    fill: "#E0E0E0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 49.2578H108.342V51.6145H109.466V49.2578Z",
    fill: "#E0E0E0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 52.5391C112.361 52.5638 110.874 52.584 109.04 52.584C107.206 52.584 105.719 52.5638 105.719 52.5391C105.719 52.5143 107.206 52.4941 109.04 52.4941C110.874 52.4941 112.361 52.5143 112.361 52.5391Z",
    fill: "#E0E0E0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 54.0781H108.342V56.4348H109.466V54.0781Z",
    fill: "#E0E0E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 57.3594C112.361 57.3841 110.874 57.4043 109.04 57.4043C107.206 57.4043 105.719 57.3841 105.719 57.3594C105.719 57.3346 107.206 57.3145 109.04 57.3145C110.874 57.3145 112.361 57.3346 112.361 57.3594Z",
    fill: "#E0E0E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 58.7598H108.342V61.1165H109.466V58.7598Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 62.041C112.361 62.0658 110.874 62.0859 109.04 62.0859C107.206 62.0859 105.719 62.0658 105.719 62.041C105.719 62.0163 107.206 61.9961 109.04 61.9961C110.874 61.9961 112.361 62.0163 112.361 62.041Z",
    fill: "#E0E0E0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 63.4609H108.342V65.8176H109.466V63.4609Z",
    fill: "#E0E0E0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M109.466 68.2236H108.342V70.5803H109.466V68.2236Z",
    fill: "#E0E0E0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 66.7432C112.361 66.7679 110.874 66.7881 109.04 66.7881C107.206 66.7881 105.719 66.7679 105.719 66.7432C105.719 66.7184 107.206 66.6982 109.04 66.6982C110.874 66.698 112.361 66.7181 112.361 66.7432Z",
    fill: "#E0E0E0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 44.5088H101.642V46.8655H102.766V44.5088Z",
    fill: "#FAFAFA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 47.79C105.662 47.8148 104.175 47.835 102.341 47.835C100.507 47.835 99.0198 47.8148 99.0198 47.79C99.0198 47.7653 100.507 47.7451 102.341 47.7451C104.175 47.7451 105.662 47.7653 105.662 47.79Z",
    fill: "#E0E0E0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 49.2588H101.642V51.6155H102.766V49.2588Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 52.541C105.662 52.5658 104.175 52.5859 102.341 52.5859C100.507 52.5859 99.0198 52.5658 99.0198 52.541C99.0198 52.5163 100.507 52.4961 102.341 52.4961C104.175 52.4961 105.662 52.5163 105.662 52.541Z",
    fill: "#E0E0E0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 54.0098H101.642V56.3665H102.766V54.0098Z",
    fill: "#FAFAFA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 57.291C105.662 57.3158 104.175 57.336 102.341 57.336C100.507 57.336 99.0198 57.3158 99.0198 57.291C99.0198 57.2663 100.507 57.2461 102.341 57.2461C104.175 57.2458 105.662 57.266 105.662 57.291Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 58.7598H101.642V61.1165H102.766V58.7598Z",
    fill: "#FAFAFA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 62.041C105.662 62.0658 104.175 62.0859 102.341 62.0859C100.507 62.0859 99.0198 62.0658 99.0198 62.041C99.0198 62.0163 100.507 61.9961 102.341 61.9961C104.175 61.9961 105.662 62.0163 105.662 62.041Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 63.5107H101.642V65.8674H102.766V63.5107Z",
    fill: "#FAFAFA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M105.662 66.792C105.662 66.8168 104.175 66.8369 102.341 66.8369C100.507 66.8369 99.0198 66.8168 99.0198 66.792C99.0198 66.7672 100.507 66.7471 102.341 66.7471C104.175 66.7471 105.662 66.7672 105.662 66.792Z",
    fill: "#E0E0E0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 68.2607H101.642V70.6174H102.766V68.2607Z",
    fill: "#FAFAFA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M120.88 60.0928H99.0781V88.6756H120.88V60.0928Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M120.88 60.0928H110.657V88.6756H120.88V60.0928Z",
    fill: "#E0E0E0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M105.61 63.9629H103.65V68.6968H105.61V63.9629Z",
    fill: "#F5F5F5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M105.61 82.4902H103.65V87.2244H105.61V82.4902Z",
    fill: "#F5F5F5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M110.658 70.5542C110.658 70.6075 108.065 70.6507 104.868 70.6507C101.67 70.6507 99.0786 70.6075 99.0786 70.5542C99.0786 70.5012 101.67 70.458 104.868 70.458C108.065 70.458 110.658 70.5012 110.658 70.5542Z",
    fill: "#F5F5F5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M105.61 73.2969H103.65V78.0307H105.61V73.2969Z",
    fill: "#F5F5F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M110.658 79.8882C110.658 79.9415 108.065 79.9844 104.868 79.9844C101.67 79.9844 99.0786 79.9412 99.0786 79.8882C99.0786 79.8352 101.67 79.792 104.868 79.792C108.065 79.792 110.658 79.8352 110.658 79.8882Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M114.789 63.9629H112.829V68.6968H114.789V63.9629Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M119.041 63.9629H117.081V68.6968H119.041V63.9629Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M114.789 72.9453H112.829V77.6792H114.789V72.9453Z",
    fill: "#F5F5F5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M119.041 72.9453H117.081V77.6792H119.041V72.9453Z",
    fill: "#F5F5F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M114.789 81.9287H112.829V86.6626H114.789V81.9287Z",
    fill: "#F5F5F5"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M119.041 81.9287H117.081V86.6626H119.041V81.9287Z",
    fill: "#F5F5F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M122.518 59.0977H97.4395V60.1284H122.518V59.0977Z",
    fill: "#E0E0E0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M121.032 60.2251C121.032 60.2784 116.159 60.3216 110.15 60.3216C104.138 60.3216 99.2664 60.2784 99.2664 60.2251C99.2664 60.1721 104.138 60.1289 110.15 60.1289C116.159 60.1289 121.032 60.1721 121.032 60.2251Z",
    fill: "#EBEBEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M98.087 88.523H76.1117L76.0161 54.001H97.9914L98.087 88.523Z",
    fill: "#EBEBEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9909 54.001H87.0034V88.523H97.9909V54.001Z",
    fill: "#E0E0E0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2853 47.2051H78.5254V54.0013H86.2853V47.2051Z",
    fill: "#EBEBEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2853 47.2051H84.4358V54.0013H86.2853V47.2051Z",
    fill: "#E0E0E0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6345 53.6045H74.1848V54.0011H98.6345V53.6045Z",
    fill: "#E0E0E0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M82.214 56.9658H80.354V60.8645H82.214V56.9658Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0036 62.3939C87.0036 62.4351 84.5437 62.4682 81.51 62.4682C78.4754 62.4682 76.0161 62.4348 76.0161 62.3939C76.0161 62.3527 78.4754 62.3193 81.51 62.3193C84.544 62.3193 87.0036 62.3527 87.0036 62.3939Z",
    fill: "#E0E0E0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M93.297 56.9658H91.437V60.8645H93.297V56.9658Z",
    fill: "#F5F5F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0869 62.3949C98.0869 62.4361 95.6269 62.4692 92.5933 62.4692C89.5584 62.4692 87.0994 62.4358 87.0994 62.3949C87.0994 62.3537 89.5587 62.3203 92.5933 62.3203C95.6269 62.3203 98.0869 62.3537 98.0869 62.3949Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M93.297 64.7061H91.437V68.6047H93.297V64.7061Z",
    fill: "#F5F5F5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0869 70.1349C98.0869 70.176 95.6269 70.2092 92.5933 70.2092C89.5584 70.2092 87.0994 70.1757 87.0994 70.1349C87.0994 70.0937 89.5587 70.0605 92.5933 70.0605C95.6269 70.0603 98.0869 70.0937 98.0869 70.1349Z",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M93.297 72.6797H91.437V76.5783H93.297V72.6797Z",
    fill: "#F5F5F5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0869 78.1085C98.0869 78.1497 95.6269 78.1828 92.5933 78.1828C89.5584 78.1828 87.0994 78.1494 87.0994 78.1085C87.0994 78.0673 89.5587 78.0342 92.5933 78.0342C95.6269 78.0342 98.0869 78.0673 98.0869 78.1085Z",
    fill: "#EBEBEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M93.297 80.6533H91.437V84.552H93.297V80.6533Z",
    fill: "#F5F5F5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0869 86.0821C98.0869 86.1233 95.6269 86.1567 92.5933 86.1567C89.5584 86.1567 87.0994 86.1233 87.0994 86.0821C87.0994 86.0409 89.5587 86.0078 92.5933 86.0078C95.6269 86.0078 98.0869 86.0412 98.0869 86.0821Z",
    fill: "#EBEBEB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M82.214 64.8242H80.354V68.7229H82.214V64.8242Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0036 70.253C87.0036 70.2942 84.5437 70.3276 81.51 70.3276C78.4754 70.3276 76.0161 70.2942 76.0161 70.253C76.0161 70.2121 78.4754 70.1787 81.51 70.1787C84.544 70.1787 87.0036 70.2118 87.0036 70.253Z",
    fill: "#E0E0E0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M82.214 72.6826H80.354V76.5813H82.214V72.6826Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0036 78.1114C87.0036 78.1526 84.5437 78.186 81.51 78.186C78.4754 78.186 76.0161 78.1526 76.0161 78.1114C76.0161 78.0702 78.4754 78.0371 81.51 78.0371C84.544 78.0368 87.0036 78.0702 87.0036 78.1114Z",
    fill: "#E0E0E0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M82.214 80.541H80.354V84.4397H82.214V80.541Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0036 85.9698C87.0036 86.011 84.5437 86.0444 81.51 86.0444C78.4754 86.0444 76.0161 86.011 76.0161 85.9698C76.0161 85.9286 78.4754 85.8955 81.51 85.8955C84.544 85.8955 87.0036 85.9286 87.0036 85.9698Z",
    fill: "#E0E0E0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M71.034 24.8203H53.0037V88.2808H71.034V24.8203Z",
    fill: "#EBEBEB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 27.0098H54.4678V30.3641H56.0734V27.0098Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 27.0098H57.8418V30.3641H59.4474V27.0098Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 27.0098H61.2161V30.3641H62.8217V27.0098Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 27.0098H64.5906V30.3641H66.1962V27.0098Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 27.0098H67.9646V30.3641H69.5702V27.0098Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 31.7012H54.4678V35.0555H56.0734V31.7012Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 31.7012H57.8418V35.0555H59.4474V31.7012Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 31.7012H61.2161V35.0555H62.8217V31.7012Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 31.7012H64.5906V35.0555H66.1962V31.7012Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 31.7012H67.9646V35.0555H69.5702V31.7012Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 36.3936H54.4678V39.7479H56.0734V36.3936Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 36.3936H57.8418V39.7479H59.4474V36.3936Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 36.3936H61.2161V39.7479H62.8217V36.3936Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 36.3936H64.5906V39.7479H66.1962V36.3936Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 36.3936H67.9646V39.7479H69.5702V36.3936Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 41.085H54.4678V44.4393H56.0734V41.085Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 41.085H57.8418V44.4393H59.4474V41.085Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 41.085H61.2161V44.4393H62.8217V41.085Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 41.085H64.5906V44.4393H66.1962V41.085Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 41.085H67.9646V44.4393H69.5702V41.085Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 45.7764H54.4678V49.1307H56.0734V45.7764Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 45.7764H57.8418V49.1307H59.4474V45.7764Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 45.7764H61.2161V49.1307H62.8217V45.7764Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 45.7764H64.5906V49.1307H66.1962V45.7764Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 45.7764H67.9646V49.1307H69.5702V45.7764Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 50.4688H54.4678V53.8231H56.0734V50.4688Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 50.4688H57.8418V53.8231H59.4474V50.4688Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 50.4688H61.2161V53.8231H62.8217V50.4688Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 50.4688H64.5906V53.8231H66.1962V50.4688Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 50.4688H67.9646V53.8231H69.5702V50.4688Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 55.1602H54.4678V58.5145H56.0734V55.1602Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 55.1602H57.8418V58.5145H59.4474V55.1602Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 55.1602H61.2161V58.5145H62.8217V55.1602Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 55.1602H64.5906V58.5145H66.1962V55.1602Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 55.1602H67.9646V58.5145H69.5702V55.1602Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 59.8516H54.4678V63.2059H56.0734V59.8516Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 59.8516H57.8418V63.2059H59.4474V59.8516Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 59.8516H61.2161V63.2059H62.8217V59.8516Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 59.8516H64.5906V63.2059H66.1962V59.8516Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 59.8516H67.9646V63.2059H69.5702V59.8516Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 64.543H54.4678V67.8973H56.0734V64.543Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 64.543H57.8418V67.8973H59.4474V64.543Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 64.543H61.2161V67.8973H62.8217V64.543Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 64.543H64.5906V67.8973H66.1962V64.543Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 64.543H67.9646V67.8973H69.5702V64.543Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 69.2354H54.4678V72.59H56.0734V69.2354Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 69.2354H57.8418V72.59H59.4474V69.2354Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 69.2354H61.2161V72.59H62.8217V69.2354Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 69.2354H64.5906V72.59H66.1962V69.2354Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 69.2354H67.9646V72.59H69.5702V69.2354Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 73.9268H54.4678V77.2811H56.0734V73.9268Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 73.9268H57.8418V77.2811H59.4474V73.9268Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 73.9268H61.2161V77.2811H62.8217V73.9268Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 73.9268H64.5906V77.2811H66.1962V73.9268Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 73.9268H67.9646V77.2811H69.5702V73.9268Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 78.6191H54.4678V81.9735H56.0734V78.6191Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 78.6191H57.8418V81.9735H59.4474V78.6191Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 78.6191H61.2161V81.9735H62.8217V78.6191Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 78.6191H64.5906V81.9735H66.1962V78.6191Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 78.6191H67.9646V81.9735H69.5702V78.6191Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0734 83.0508H54.4678V86.4051H56.0734V83.0508Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4474 83.0508H57.8418V86.4051H59.4474V83.0508Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 83.0508H61.2161V86.4051H62.8217V83.0508Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 83.0508H64.5906V86.4051H66.1962V83.0508Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 83.0508H67.9646V86.4051H69.5702V83.0508Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9098 24.8203H71.0339V88.2808H78.9098V24.8203Z",
    fill: "#E0E0E0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 27.0098H61.2161V30.3641H62.8217V27.0098Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 27.0098H64.5906V30.3641H66.1962V27.0098Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 27.0098H67.9646V30.3641H69.5702V27.0098Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 31.7021H61.2161V35.0565H62.8217V31.7021Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 31.7021H64.5906V35.0565H66.1962V31.7021Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 31.7021H67.9646V35.0565H69.5702V31.7021Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 36.3936H61.2161V39.7479H62.8217V36.3936Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 36.3936H64.5906V39.7479H66.1962V36.3936Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 36.3936H67.9646V39.7479H69.5702V36.3936Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 41.085H61.2161V44.4393H62.8217V41.085Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 41.085H64.5906V44.4393H66.1962V41.085Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 41.085H67.9646V44.4393H69.5702V41.085Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 45.7773H61.2161V49.1317H62.8217V45.7773Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 45.7773H64.5906V49.1317H66.1962V45.7773Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 45.7773H67.9646V49.1317H69.5702V45.7773Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 50.4688H61.2161V53.8231H62.8217V50.4688Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 50.4688H64.5906V53.8231H66.1962V50.4688Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 50.4688H67.9646V53.8231H69.5702V50.4688Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 55.1602H61.2161V58.5145H62.8217V55.1602Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 55.1602H64.5906V58.5145H66.1962V55.1602Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 55.1602H67.9646V58.5145H69.5702V55.1602Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 59.8525H61.2161V63.2069H62.8217V59.8525Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 59.8525H64.5906V63.2069H66.1962V59.8525Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 59.8525H67.9646V63.2069H69.5702V59.8525Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 64.5439H61.2161V67.8983H62.8217V64.5439Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 64.5439H64.5906V67.8983H66.1962V64.5439Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 64.5439H67.9646V67.8983H69.5702V64.5439Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 69.2354H61.2161V72.59H62.8217V69.2354Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 69.2354H64.5906V72.59H66.1962V69.2354Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 69.2354H67.9646V72.59H69.5702V69.2354Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 73.9268H61.2161V77.2811H62.8217V73.9268Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 73.9268H64.5906V77.2811H66.1962V73.9268Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 73.9268H67.9646V77.2811H69.5702V73.9268Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 78.6191H61.2161V81.9735H62.8217V78.6191Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 78.6191H64.5906V81.9735H66.1962V78.6191Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 78.6191H67.9646V81.9735H69.5702V78.6191Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8217 83.0518H61.2161V86.4061H62.8217V83.0518Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1962 83.0518H64.5906V86.4061H66.1962V83.0518Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5702 83.0518H67.9646V86.4061H69.5702V83.0518Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 27.0098H72.8162V30.3641H74.4218V27.0098Z",
    fill: "#EBEBEB"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 27.0098H76.1904V30.3641H77.7961V27.0098Z",
    fill: "#EBEBEB"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 31.7021H72.8162V35.0565H74.4218V31.7021Z",
    fill: "#EBEBEB"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 31.7021H76.1904V35.0565H77.7961V31.7021Z",
    fill: "#EBEBEB"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 36.3936H72.8162V39.7479H74.4218V36.3936Z",
    fill: "#EBEBEB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 36.3936H76.1904V39.7479H77.7961V36.3936Z",
    fill: "#EBEBEB"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 41.085H72.8162V44.4393H74.4218V41.085Z",
    fill: "#EBEBEB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 41.085H76.1904V44.4393H77.7961V41.085Z",
    fill: "#EBEBEB"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 45.7773H72.8162V49.1317H74.4218V45.7773Z",
    fill: "#EBEBEB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 45.7773H76.1904V49.1317H77.7961V45.7773Z",
    fill: "#EBEBEB"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 50.4688H72.8162V53.8231H74.4218V50.4688Z",
    fill: "#EBEBEB"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 50.4688H76.1904V53.8231H77.7961V50.4688Z",
    fill: "#EBEBEB"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 55.1602H72.8162V58.5145H74.4218V55.1602Z",
    fill: "#EBEBEB"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 55.1602H76.1904V58.5145H77.7961V55.1602Z",
    fill: "#EBEBEB"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 59.8525H72.8162V63.2069H74.4218V59.8525Z",
    fill: "#EBEBEB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 59.8525H76.1904V63.2069H77.7961V59.8525Z",
    fill: "#EBEBEB"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 64.5439H72.8162V67.8983H74.4218V64.5439Z",
    fill: "#EBEBEB"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 64.5439H76.1904V67.8983H77.7961V64.5439Z",
    fill: "#EBEBEB"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 69.2354H72.8162V72.59H74.4218V69.2354Z",
    fill: "#EBEBEB"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 69.2354H76.1904V72.59H77.7961V69.2354Z",
    fill: "#EBEBEB"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 73.9268H72.8162V77.2811H74.4218V73.9268Z",
    fill: "#EBEBEB"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 73.9268H76.1904V77.2811H77.7961V73.9268Z",
    fill: "#EBEBEB"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 78.6191H72.8162V81.9735H74.4218V78.6191Z",
    fill: "#EBEBEB"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 78.6191H76.1904V81.9735H77.7961V78.6191Z",
    fill: "#EBEBEB"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4218 83.0518H72.8162V86.4061H74.4218V83.0518Z",
    fill: "#EBEBEB"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7961 83.0518H76.1904V86.4061H77.7961V83.0518Z",
    fill: "#EBEBEB"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M100.614 47.0391L81.7129 52.3544V88.3691H100.614V47.0391Z",
    fill: "#E0E0E0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1533 52.7127L83.3027 85.8301H98.6772V48.3438L83.1533 52.7127Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3105 86.5846C87.2375 86.5846 87.1782 78.6376 87.1782 68.8366C87.1782 59.0323 87.2375 51.0869 87.3105 51.0869C87.3834 51.0869 87.4427 59.0323 87.4427 68.8366C87.4424 78.6376 87.3834 86.5846 87.3105 86.5846Z",
    fill: "#E0E0E0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7726 86.5845C93.6997 86.5845 93.6404 78.1948 93.6404 67.8478C93.6404 57.4974 93.6997 49.1094 93.7726 49.1094C93.8456 49.1094 93.9049 57.4974 93.9049 67.8478C93.9046 78.1948 93.8456 86.5845 93.7726 86.5845Z",
    fill: "#E0E0E0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7385 57.7687C99.7385 57.841 95.9098 57.8998 91.1885 57.8998C86.4652 57.8998 82.6377 57.8413 82.6377 57.7687C82.6377 57.6964 86.4655 57.6377 91.1885 57.6377C95.9098 57.638 99.7385 57.6964 99.7385 57.7687Z",
    fill: "#E0E0E0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5788 67.9035C99.5788 67.9758 95.7504 68.0345 91.0289 68.0345C86.3055 68.0345 82.478 67.9758 82.478 67.9035C82.478 67.8312 86.3058 67.7725 91.0289 67.7725C95.7504 67.7727 99.5788 67.8312 99.5788 67.9035Z",
    fill: "#E0E0E0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M100.538 78.1174C100.538 78.1897 96.566 78.2484 91.6679 78.2484C86.7682 78.2484 82.7974 78.1897 82.7974 78.1174C82.7974 78.0451 86.7682 77.9863 91.6679 77.9863C96.566 77.9863 100.538 78.0451 100.538 78.1174Z",
    fill: "#E0E0E0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M100.542 47.0392C100.562 47.1089 96.3792 48.3461 91.2001 49.8026C86.0192 51.2596 81.8046 52.3839 81.7845 52.3142C81.7644 52.2448 85.9468 51.0076 91.1277 49.5506C96.3068 48.0941 100.522 46.9695 100.542 47.0392Z",
    fill: "#E0E0E0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1747 65.3377C88.1229 65.2864 89.0525 64.2825 90.2506 63.0953C91.449 61.9079 92.462 60.9872 92.5137 61.0382C92.5652 61.0891 91.6359 62.0931 90.4375 63.2805C89.2394 64.4679 88.2261 65.389 88.1747 65.3377Z",
    fill: "#E0E0E0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0635 61.2606C91.1138 61.3131 90.7793 61.7096 90.3159 62.1462C89.8526 62.5831 89.4364 62.8945 89.3861 62.842C89.3358 62.7896 89.6704 62.3933 90.1337 61.9564C90.597 61.5196 91.0133 61.2082 91.0635 61.2606Z",
    fill: "#E0E0E0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M92.13 72.7269C92.182 72.7776 91.3882 73.662 90.3572 74.7023C89.3259 75.7428 88.4475 76.5449 88.3955 76.4942C88.3435 76.4435 89.137 75.5594 90.1686 74.5188C91.1995 73.4786 92.0776 72.6762 92.13 72.7269Z",
    fill: "#E0E0E0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M90.679 73.1751C90.7331 73.2235 90.4695 73.5999 90.0904 74.0157C89.7111 74.4316 89.3597 74.7294 89.3056 74.6807C89.2516 74.6321 89.5149 74.2559 89.8942 73.8401C90.2735 73.4245 90.6247 73.1267 90.679 73.1751Z",
    fill: "#E0E0E0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2081 52.72C97.2636 52.767 96.8692 53.3147 96.3271 53.9434C95.7847 54.5721 95.3005 55.0436 95.245 54.9967C95.1894 54.9497 95.5839 54.4019 96.126 53.7732C96.6681 53.1445 97.1526 52.6731 97.2081 52.72Z",
    fill: "#E0E0E0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7677 52.0537C96.8218 52.1024 96.5416 52.4961 96.1419 52.933C95.742 53.3702 95.3743 53.685 95.3199 53.6363C95.2658 53.5879 95.546 53.1942 95.946 52.757C96.3457 52.3201 96.7137 52.0054 96.7677 52.0537Z",
    fill: "#E0E0E0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8905 81.7054C85.9501 81.7471 85.7086 82.1863 85.3514 82.6863C84.9938 83.1862 84.6561 83.5575 84.5962 83.5157C84.5366 83.474 84.7779 83.0348 85.1354 82.5348C85.4932 82.0348 85.831 81.6636 85.8905 81.7054Z",
    fill: "#E0E0E0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4339 81.1014C85.4871 81.1509 85.2746 81.4611 84.9595 81.7943C84.6441 82.1275 84.3453 82.3576 84.2919 82.3081C84.2387 82.2585 84.4511 81.9484 84.7665 81.6152C85.0816 81.2822 85.3807 81.0521 85.4339 81.1014Z",
    fill: "#E0E0E0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M123.895 38.0723H107.831V88.5172H123.895V38.0723Z",
    fill: "#F5F5F5"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M123.895 38.0723H115.863V88.3784H123.895V38.0723Z",
    fill: "#EBEBEB"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M115.337 33.1201H109.665V38.0723H115.337V33.1201Z",
    fill: "#F5F5F5"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M115.338 33.1201H113.986V38.0723H115.338V33.1201Z",
    fill: "#EBEBEB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M106.492 38.0721V37.7832H124.365V38.0721",
    fill: "#E0E0E0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 40.2324H111.002V43.0733H112.361V40.2324Z",
    fill: "#FAFAFA"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 44.1879C115.863 44.2179 114.064 44.2421 111.847 44.2421C109.629 44.2421 107.831 44.2179 107.831 44.1879C107.831 44.158 109.628 44.1338 111.847 44.1338C114.065 44.1335 115.863 44.158 115.863 44.1879Z",
    fill: "#E0E0E0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 40.2324H119.104V43.0733H120.463V40.2324Z",
    fill: "#E0E0E0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M123.965 44.1879C123.965 44.2179 122.166 44.2421 119.949 44.2421C117.73 44.2421 115.933 44.2179 115.933 44.1879C115.933 44.158 117.731 44.1338 119.949 44.1338C122.167 44.1335 123.965 44.158 123.965 44.1879Z",
    fill: "#E0E0E0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 45.873H119.104V48.7139H120.463V45.873Z",
    fill: "#E0E0E0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M123.965 49.8286C123.965 49.8585 122.166 49.8827 119.949 49.8827C117.73 49.8827 115.933 49.8582 115.933 49.8286C115.933 49.7986 117.731 49.7744 119.949 49.7744C122.167 49.7744 123.965 49.7986 123.965 49.8286Z",
    fill: "#E0E0E0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 51.6836H119.104V54.5244H120.463V51.6836Z",
    fill: "#E0E0E0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M123.965 55.6391C123.965 55.6691 122.166 55.6932 119.949 55.6932C117.73 55.6932 115.933 55.6691 115.933 55.6391C115.933 55.6091 117.731 55.585 119.949 55.585C122.167 55.585 123.965 55.6091 123.965 55.6391Z",
    fill: "#E0E0E0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 57.4932H119.104V60.334H120.463V57.4932Z",
    fill: "#E0E0E0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M123.965 61.4487C123.965 61.4786 122.166 61.5028 119.949 61.5028C117.73 61.5028 115.933 61.4786 115.933 61.4487C115.933 61.4187 117.731 61.3945 119.949 61.3945C122.167 61.3945 123.965 61.4187 123.965 61.4487Z",
    fill: "#E0E0E0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 63.1377H119.104V65.9785H120.463V63.1377Z",
    fill: "#E0E0E0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M123.965 67.0932C123.965 67.1232 122.166 67.1474 119.949 67.1474C117.73 67.1474 115.933 67.1232 115.933 67.0932C115.933 67.0633 117.731 67.0391 119.949 67.0391C122.167 67.0388 123.965 67.0633 123.965 67.0932Z",
    fill: "#E0E0E0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 68.8047H119.104V71.6458H120.463V68.8047Z",
    fill: "#E0E0E0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M120.463 74.5459H119.104V77.3867H120.463V74.5459Z",
    fill: "#E0E0E0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M123.965 72.7612C123.965 72.7911 122.166 72.8153 119.949 72.8153C117.73 72.8153 115.933 72.7908 115.933 72.7612C115.933 72.7312 117.731 72.707 119.949 72.707C122.167 72.7067 123.965 72.7309 123.965 72.7612Z",
    fill: "#E0E0E0"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 45.959H111.002V48.7998H112.361V45.959Z",
    fill: "#FAFAFA"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 49.9145C115.863 49.9444 114.064 49.9686 111.847 49.9686C109.629 49.9686 107.831 49.9444 107.831 49.9145C107.831 49.8845 109.628 49.8604 111.847 49.8604C114.065 49.8604 115.863 49.8845 115.863 49.9145Z",
    fill: "#E0E0E0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 51.6855H111.002V54.5264H112.361V51.6855Z",
    fill: "#FAFAFA"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 55.6411C115.863 55.671 114.064 55.6952 111.847 55.6952C109.629 55.6952 107.831 55.671 107.831 55.6411C107.831 55.6111 109.628 55.5869 111.847 55.5869C114.065 55.5866 115.863 55.6111 115.863 55.6411Z",
    fill: "#E0E0E0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 57.4111H111.002V60.252H112.361V57.4111Z",
    fill: "#FAFAFA"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 61.3676C115.863 61.3976 114.064 61.4218 111.847 61.4218C109.629 61.4218 107.831 61.3976 107.831 61.3676C107.831 61.3377 109.628 61.3135 111.847 61.3135C114.065 61.3135 115.863 61.3377 115.863 61.3676Z",
    fill: "#E0E0E0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 63.1377H111.002V65.9785H112.361V63.1377Z",
    fill: "#FAFAFA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 67.0942C115.863 67.1241 114.064 67.1483 111.847 67.1483C109.629 67.1483 107.831 67.1241 107.831 67.0942C107.831 67.0642 109.628 67.04 111.847 67.04C114.065 67.0398 115.863 67.0642 115.863 67.0942Z",
    fill: "#E0E0E0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 68.8643H111.002V71.7051H112.361V68.8643Z",
    fill: "#FAFAFA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M115.863 72.8207C115.863 72.8507 114.064 72.8749 111.847 72.8749C109.629 72.8749 107.831 72.8507 107.831 72.8207C107.831 72.7908 109.628 72.7666 111.847 72.7666C114.065 72.7666 115.863 72.7908 115.863 72.8207Z",
    fill: "#E0E0E0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 74.5908H111.002V77.4316H112.361V74.5908Z",
    fill: "#FAFAFA"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M108.009 52.377H96.4666V88.6223H108.009V52.377Z",
    fill: "#F5F5F5"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M108.009 52.377H102.238V88.5224H108.009V52.377Z",
    fill: "#EBEBEB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M101.86 48.8184H97.7844V52.3766H101.86V48.8184Z",
    fill: "#F5F5F5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M101.86 48.8184H100.889V52.3766H101.86V48.8184Z",
    fill: "#EBEBEB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5044 52.3763V52.1689H108.347V52.3763",
    fill: "#E0E0E0"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 53.9287H98.7446V55.9701H99.7216V53.9287Z",
    fill: "#FAFAFA"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 56.7713C102.238 56.7929 100.946 56.8102 99.3523 56.8102C97.7583 56.8102 96.4666 56.7926 96.4666 56.7713C96.4666 56.7497 97.7583 56.7324 99.3523 56.7324C100.946 56.7324 102.238 56.75 102.238 56.7713Z",
    fill: "#E0E0E0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 53.9287H104.566V55.9701H105.543V53.9287Z",
    fill: "#E0E0E0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 56.7713C108.059 56.7929 106.767 56.8102 105.174 56.8102C103.58 56.8102 102.288 56.7926 102.288 56.7713C102.288 56.7497 103.58 56.7324 105.174 56.7324C106.767 56.7324 108.059 56.75 108.059 56.7713Z",
    fill: "#E0E0E0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 57.9814H104.566V60.0228H105.543V57.9814Z",
    fill: "#E0E0E0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 60.824C108.059 60.8456 106.767 60.8629 105.174 60.8629C103.58 60.8629 102.288 60.8453 102.288 60.824C102.288 60.8024 103.58 60.7852 105.174 60.7852C106.767 60.7852 108.059 60.8024 108.059 60.824Z",
    fill: "#E0E0E0"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 62.1562H104.566V64.1976H105.543V62.1562Z",
    fill: "#E0E0E0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 64.9988C108.059 65.0204 106.767 65.0377 105.174 65.0377C103.58 65.0377 102.288 65.0202 102.288 64.9988C102.288 64.9772 103.58 64.96 105.174 64.96C106.767 64.9597 108.059 64.9772 108.059 64.9988Z",
    fill: "#E0E0E0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 66.3311H104.566V68.3724H105.543V66.3311Z",
    fill: "#E0E0E0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 69.1736C108.059 69.1952 106.767 69.2128 105.174 69.2128C103.58 69.2128 102.288 69.1952 102.288 69.1736C102.288 69.1523 103.58 69.1348 105.174 69.1348C106.767 69.1348 108.059 69.152 108.059 69.1736Z",
    fill: "#E0E0E0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 70.3867H104.566V72.4281H105.543V70.3867Z",
    fill: "#E0E0E0"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 73.2293C108.059 73.2509 106.767 73.2685 105.174 73.2685C103.58 73.2685 102.288 73.2509 102.288 73.2293C102.288 73.208 103.58 73.1904 105.174 73.1904C106.767 73.1901 108.059 73.2077 108.059 73.2293Z",
    fill: "#E0E0E0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 74.459H104.566V76.5003H105.543V74.459Z",
    fill: "#E0E0E0"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M105.543 78.584H104.566V80.6253H105.543V78.584Z",
    fill: "#E0E0E0"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M108.059 77.3016C108.059 77.3232 106.767 77.3405 105.174 77.3405C103.58 77.3405 102.288 77.3229 102.288 77.3016C102.288 77.28 103.58 77.2627 105.174 77.2627C106.767 77.2627 108.059 77.2803 108.059 77.3016Z",
    fill: "#E0E0E0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 58.043H98.7446V60.0843H99.7216V58.043Z",
    fill: "#FAFAFA"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 60.8856C102.238 60.9072 100.946 60.9244 99.3523 60.9244C97.7583 60.9244 96.4666 60.9072 96.4666 60.8856C96.4666 60.864 97.7583 60.8467 99.3523 60.8467C100.946 60.8467 102.238 60.864 102.238 60.8856Z",
    fill: "#E0E0E0"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 62.1572H98.7446V64.1986H99.7216V62.1572Z",
    fill: "#FAFAFA"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 64.9998C102.238 65.0214 100.946 65.0387 99.3523 65.0387C97.7583 65.0387 96.4666 65.0214 96.4666 64.9998C96.4666 64.9782 97.7583 64.9609 99.3523 64.9609C100.946 64.9607 102.238 64.9782 102.238 64.9998Z",
    fill: "#E0E0E0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 66.2725H98.7446V68.3138H99.7216V66.2725Z",
    fill: "#FAFAFA"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 69.1151C102.238 69.1367 100.946 69.1539 99.3523 69.1539C97.7583 69.1539 96.4666 69.1367 96.4666 69.1151C96.4666 69.0935 97.7583 69.0762 99.3523 69.0762C100.946 69.0762 102.238 69.0937 102.238 69.1151Z",
    fill: "#E0E0E0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 70.3867H98.7446V72.4281H99.7216V70.3867Z",
    fill: "#FAFAFA"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 73.2293C102.238 73.2509 100.946 73.2685 99.3523 73.2685C97.7583 73.2685 96.4666 73.2509 96.4666 73.2293C96.4666 73.208 97.7583 73.1904 99.3523 73.1904C100.946 73.1901 102.238 73.2077 102.238 73.2293Z",
    fill: "#E0E0E0"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 74.501H98.7446V76.5423H99.7216V74.501Z",
    fill: "#FAFAFA"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 77.3436C102.238 77.3652 100.946 77.3824 99.3523 77.3824C97.7583 77.3824 96.4666 77.3649 96.4666 77.3436C96.4666 77.322 97.7583 77.3047 99.3523 77.3047C100.946 77.3047 102.238 77.3222 102.238 77.3436Z",
    fill: "#E0E0E0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7216 78.6152H98.7446V80.6566H99.7216V78.6152Z",
    fill: "#FAFAFA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M142.522 59.0674H126.987V88.3748H142.522V59.0674Z",
    fill: "#E0E0E0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M142.522 59.0674H135.238V88.3748H142.522V59.0674Z",
    fill: "#EBEBEB"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M131.641 61.8252H130.244V65.1985H131.641V61.8252Z",
    fill: "#F5F5F5"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M131.641 75.0283H130.244V78.4017H131.641V75.0283Z",
    fill: "#F5F5F5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M135.238 66.5224C135.238 66.5515 133.39 66.5751 131.113 66.5751C128.834 66.5751 126.987 66.5515 126.987 66.5224C126.987 66.4933 128.834 66.4697 131.113 66.4697C133.39 66.47 135.238 66.4936 135.238 66.5224Z",
    fill: "#F5F5F5"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M131.641 68.4766H130.244V71.8499H131.641V68.4766Z",
    fill: "#F5F5F5"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M135.238 73.1745C135.238 73.2036 133.39 73.2272 131.113 73.2272C128.834 73.2272 126.987 73.2039 126.987 73.1745C126.987 73.1454 128.834 73.1221 131.113 73.1221C133.39 73.1218 135.238 73.1454 135.238 73.1745Z",
    fill: "#F5F5F5"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M138.182 61.8252H136.785V65.1985H138.182V61.8252Z",
    fill: "#E0E0E0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M141.212 61.8252H139.815V65.1985H141.212V61.8252Z",
    fill: "#E0E0E0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M138.182 68.2256H136.785V71.5989H138.182V68.2256Z",
    fill: "#E0E0E0"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M141.212 68.2256H139.815V71.5989H141.212V68.2256Z",
    fill: "#E0E0E0"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M138.182 74.627H136.785V78.0003H138.182V74.627Z",
    fill: "#E0E0E0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M141.212 74.627H139.815V78.0003H141.212V74.627Z",
    fill: "#E0E0E0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M143.69 58.3584H125.819V59.0928H143.69V58.3584Z",
    fill: "#E0E0E0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M142.631 59.1621C142.631 59.1912 139.159 59.2148 134.876 59.2148C130.592 59.2148 127.121 59.1912 127.121 59.1621C127.121 59.133 130.593 59.1094 134.876 59.1094C139.158 59.1094 142.631 59.133 142.631 59.1621Z",
    fill: "#EBEBEB"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M200.809 37.9551H187.525V79.8015H200.809V37.9551Z",
    fill: "#F5F5F5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M200.809 37.9551H194.167V79.6863H200.809V37.9551Z",
    fill: "#EBEBEB"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M193.733 33.8467H189.042V37.955H193.733V33.8467Z",
    fill: "#F5F5F5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M193.733 33.8467H192.615V37.955H193.733V33.8467Z",
    fill: "#EBEBEB"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M186.418 37.9554V37.7158H201.198V37.9554",
    fill: "#E0E0E0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 39.7471H190.147V42.1038H191.272V39.7471Z",
    fill: "#FAFAFA"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M194.167 43.0283C194.167 43.0534 192.68 43.0733 190.847 43.0733C189.012 43.0733 187.525 43.0531 187.525 43.0283C187.525 43.0036 189.012 42.9834 190.847 42.9834C192.68 42.9831 194.167 43.0033 194.167 43.0283Z",
    fill: "#E0E0E0"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 39.7471H196.847V42.1038H197.971V39.7471Z",
    fill: "#E0E0E0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 43.0293C200.867 43.0544 199.38 43.0742 197.546 43.0742C195.712 43.0742 194.225 43.0541 194.225 43.0293C194.225 43.0045 195.711 42.9844 197.546 42.9844C199.38 42.9841 200.867 43.0042 200.867 43.0293Z",
    fill: "#E0E0E0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 44.4258H196.847V46.7825H197.971V44.4258Z",
    fill: "#E0E0E0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 47.707C200.867 47.7318 199.38 47.752 197.546 47.752C195.712 47.752 194.225 47.7318 194.225 47.707C194.225 47.6823 195.711 47.6621 197.546 47.6621C199.38 47.6621 200.867 47.6823 200.867 47.707Z",
    fill: "#E0E0E0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 49.2461H196.847V51.6028H197.971V49.2461Z",
    fill: "#E0E0E0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 52.5283C200.867 52.5531 199.38 52.5733 197.546 52.5733C195.712 52.5733 194.225 52.5531 194.225 52.5283C194.225 52.5036 195.711 52.4834 197.546 52.4834C199.38 52.4834 200.867 52.5033 200.867 52.5283Z",
    fill: "#E0E0E0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 54.0664H196.847V56.4231H197.971V54.0664Z",
    fill: "#E0E0E0"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 57.3477C200.867 57.3724 199.38 57.3926 197.546 57.3926C195.712 57.3926 194.225 57.3724 194.225 57.3477C194.225 57.3229 195.711 57.3027 197.546 57.3027C199.38 57.3027 200.867 57.3229 200.867 57.3477Z",
    fill: "#E0E0E0"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 58.748H196.847V61.1048H197.971V58.748Z",
    fill: "#E0E0E0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 62.0293C200.867 62.0541 199.38 62.0742 197.546 62.0742C195.712 62.0742 194.225 62.0541 194.225 62.0293C194.225 62.0045 195.711 61.9844 197.546 61.9844C199.38 61.9844 200.867 62.0045 200.867 62.0293Z",
    fill: "#E0E0E0"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 63.4492H196.847V65.8059H197.971V63.4492Z",
    fill: "#E0E0E0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M197.971 68.2119H196.847V70.5686H197.971V68.2119Z",
    fill: "#E0E0E0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 66.7315C200.867 66.7562 199.38 66.7764 197.546 66.7764C195.712 66.7764 194.225 66.7562 194.225 66.7315C194.225 66.7067 195.711 66.6865 197.546 66.6865C199.38 66.6865 200.867 66.7067 200.867 66.7315Z",
    fill: "#E0E0E0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 44.4971H190.147V46.8538H191.272V44.4971Z",
    fill: "#FAFAFA"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M194.167 47.7783C194.167 47.8031 192.68 47.8233 190.847 47.8233C189.012 47.8233 187.525 47.8031 187.525 47.7783C187.525 47.7536 189.012 47.7334 190.847 47.7334C192.68 47.7334 194.167 47.7536 194.167 47.7783Z",
    fill: "#E0E0E0"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 49.2471H190.147V51.6038H191.272V49.2471Z",
    fill: "#FAFAFA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M194.167 52.5293C194.167 52.5541 192.68 52.5742 190.847 52.5742C189.012 52.5742 187.525 52.5541 187.525 52.5293C187.525 52.5045 189.012 52.4844 190.847 52.4844C192.68 52.4841 194.167 52.5043 194.167 52.5293Z",
    fill: "#E0E0E0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 53.998H190.147V56.3548H191.272V53.998Z",
    fill: "#FAFAFA"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M194.167 57.2793C194.167 57.3041 192.68 57.3242 190.847 57.3242C189.012 57.3242 187.525 57.3041 187.525 57.2793C187.525 57.2545 189.012 57.2344 190.847 57.2344C192.68 57.2344 194.167 57.2545 194.167 57.2793Z",
    fill: "#E0E0E0"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 58.748H190.147V61.1048H191.272V58.748Z",
    fill: "#FAFAFA"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M194.167 62.0293C194.167 62.0541 192.68 62.0742 190.847 62.0742C189.012 62.0742 187.525 62.0541 187.525 62.0293C187.525 62.0045 189.012 61.9844 190.847 61.9844C192.68 61.9844 194.167 62.0045 194.167 62.0293Z",
    fill: "#E0E0E0"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 63.499H190.147V65.8557H191.272V63.499Z",
    fill: "#FAFAFA"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M194.167 66.7803C194.167 66.805 192.68 66.8252 190.847 66.8252C189.012 66.8252 187.525 66.805 187.525 66.7803C187.525 66.7555 189.012 66.7354 190.847 66.7354C192.68 66.7351 194.167 66.7552 194.167 66.7803Z",
    fill: "#E0E0E0"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M191.272 68.249H190.147V70.6057H191.272V68.249Z",
    fill: "#FAFAFA"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M209.385 60.0811H187.584V88.6639H209.385V60.0811Z",
    fill: "#EBEBEB"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M209.385 60.0811H199.163V88.6639H209.385V60.0811Z",
    fill: "#E0E0E0"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M194.116 63.9502H192.155V68.6841H194.116V63.9502Z",
    fill: "#F5F5F5"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M194.116 82.4775H192.155V87.2117H194.116V82.4775Z",
    fill: "#F5F5F5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M199.163 70.5415C199.163 70.5948 196.571 70.638 193.374 70.638C190.176 70.638 187.584 70.5948 187.584 70.5415C187.584 70.4885 190.176 70.4453 193.374 70.4453C196.571 70.4453 199.163 70.4885 199.163 70.5415Z",
    fill: "#F5F5F5"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M194.116 73.2842H192.155V78.018H194.116V73.2842Z",
    fill: "#F5F5F5"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M199.163 79.8765C199.163 79.9297 196.571 79.9727 193.374 79.9727C190.176 79.9727 187.584 79.9295 187.584 79.8765C187.584 79.8235 190.176 79.7803 193.374 79.7803C196.571 79.78 199.163 79.8232 199.163 79.8765Z",
    fill: "#F5F5F5"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M203.294 63.9502H201.334V68.6841H203.294V63.9502Z",
    fill: "#F5F5F5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M207.547 63.9502H205.587V68.6841H207.547V63.9502Z",
    fill: "#F5F5F5"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M203.294 72.9336H201.334V77.6674H203.294V72.9336Z",
    fill: "#F5F5F5"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M207.547 72.9336H205.587V77.6674H207.547V72.9336Z",
    fill: "#F5F5F5"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M203.294 81.916H201.334V86.6499H203.294V81.916Z",
    fill: "#F5F5F5"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M207.547 81.916H205.587V86.6499H207.547V81.916Z",
    fill: "#F5F5F5"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M211.024 59.0859H185.945V60.1167H211.024V59.0859Z",
    fill: "#E0E0E0"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M209.538 60.2134C209.538 60.2667 204.665 60.3099 198.655 60.3099C192.644 60.3099 187.772 60.2667 187.772 60.2134C187.772 60.1604 192.644 60.1172 198.655 60.1172C204.665 60.1172 209.538 60.1604 209.538 60.2134Z",
    fill: "#EBEBEB"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M186.593 88.5112H164.617L164.522 53.9893H186.497L186.593 88.5112Z",
    fill: "#EBEBEB"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M186.497 53.9893H175.509V88.5112H186.497V53.9893Z",
    fill: "#E0E0E0"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M174.791 47.1934H167.031V53.9896H174.791V47.1934Z",
    fill: "#EBEBEB"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M174.791 47.1934H172.941V53.9896H174.791V47.1934Z",
    fill: "#E0E0E0"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M187.14 53.5938H162.69V53.9903H187.14V53.5938Z",
    fill: "#E0E0E0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M170.719 56.9541H168.859V60.8528H170.719V56.9541Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M175.509 62.3822C175.509 62.4234 173.049 62.4565 170.016 62.4565C166.981 62.4565 164.522 62.4231 164.522 62.3822C164.522 62.341 166.981 62.3076 170.016 62.3076C173.05 62.3076 175.509 62.341 175.509 62.3822Z",
    fill: "#E0E0E0"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M181.803 56.9541H179.943V60.8528H181.803V56.9541Z",
    fill: "#F5F5F5"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M186.592 62.3832C186.592 62.4244 184.132 62.4575 181.099 62.4575C178.064 62.4575 175.605 62.4241 175.605 62.3832C175.605 62.342 178.064 62.3086 181.099 62.3086C184.133 62.3086 186.592 62.342 186.592 62.3832Z",
    fill: "#EBEBEB"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M181.803 64.6943H179.943V68.593H181.803V64.6943Z",
    fill: "#F5F5F5"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M186.592 70.1231C186.592 70.1643 184.132 70.1974 181.099 70.1974C178.064 70.1974 175.605 70.164 175.605 70.1231C175.605 70.0819 178.064 70.0488 181.099 70.0488C184.133 70.0488 186.592 70.0819 186.592 70.1231Z",
    fill: "#EBEBEB"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M181.803 72.668H179.943V76.5666H181.803V72.668Z",
    fill: "#F5F5F5"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M186.592 78.0968C186.592 78.1379 184.132 78.1711 181.099 78.1711C178.064 78.1711 175.605 78.1377 175.605 78.0968C175.605 78.0556 178.064 78.0225 181.099 78.0225C184.133 78.0225 186.592 78.0556 186.592 78.0968Z",
    fill: "#EBEBEB"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M181.803 80.6416H179.943V84.5403H181.803V80.6416Z",
    fill: "#F5F5F5"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M186.592 86.0704C186.592 86.1116 184.132 86.145 181.099 86.145C178.064 86.145 175.605 86.1116 175.605 86.0704C175.605 86.0292 178.064 85.9961 181.099 85.9961C184.133 85.9958 186.592 86.0292 186.592 86.0704Z",
    fill: "#EBEBEB"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M170.719 64.8125H168.859V68.7112H170.719V64.8125Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M175.509 70.2413C175.509 70.2825 173.049 70.3159 170.016 70.3159C166.981 70.3159 164.522 70.2825 164.522 70.2413C164.522 70.2001 166.981 70.167 170.016 70.167C173.05 70.167 175.509 70.2004 175.509 70.2413Z",
    fill: "#E0E0E0"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M170.719 72.6709H168.859V76.5696H170.719V72.6709Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M175.509 78.0997C175.509 78.1409 173.049 78.1743 170.016 78.1743C166.981 78.1743 164.522 78.1409 164.522 78.0997C164.522 78.0585 166.981 78.0254 170.016 78.0254C173.05 78.0251 175.509 78.0585 175.509 78.0997Z",
    fill: "#E0E0E0"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M170.719 80.5293H168.859V84.4279H170.719V80.5293Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M175.509 85.9581C175.509 85.9993 173.049 86.0327 170.016 86.0327C166.981 86.0327 164.522 85.9993 164.522 85.9581C164.522 85.9169 166.981 85.8838 170.016 85.8838C173.05 85.8838 175.509 85.9172 175.509 85.9581Z",
    fill: "#E0E0E0"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M159.563 25.0625H141.532V88.523H159.563V25.0625Z",
    fill: "#EBEBEB"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 27.252H142.996V30.6063H144.602V27.252Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 27.252H146.37V30.6063H147.976V27.252Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 27.252H149.745V30.6063H151.35V27.252Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 27.252H153.119V30.6063H154.725V27.252Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 27.252H156.493V30.6063H158.099V27.252Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 31.9434H142.996V35.2977H144.602V31.9434Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 31.9434H146.37V35.2977H147.976V31.9434Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 31.9434H149.745V35.2977H151.35V31.9434Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 31.9434H153.119V35.2977H154.725V31.9434Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 31.9434H156.493V35.2977H158.099V31.9434Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 36.6357H142.996V39.9901H144.602V36.6357Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 36.6357H146.37V39.9901H147.976V36.6357Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 36.6357H149.745V39.9901H151.35V36.6357Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 36.6357H153.119V39.9901H154.725V36.6357Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 36.6357H156.493V39.9901H158.099V36.6357Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 41.3271H142.996V44.6815H144.602V41.3271Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 41.3271H146.37V44.6815H147.976V41.3271Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 41.3271H149.745V44.6815H151.35V41.3271Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 41.3271H153.119V44.6815H154.725V41.3271Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 41.3271H156.493V44.6815H158.099V41.3271Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 46.0186H142.996V49.3729H144.602V46.0186Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 46.0186H146.37V49.3729H147.976V46.0186Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 46.0186H149.745V49.3729H151.35V46.0186Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 46.0186H153.119V49.3729H154.725V46.0186Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 46.0186H156.493V49.3729H158.099V46.0186Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 50.7109H142.996V54.0653H144.602V50.7109Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 50.7109H146.37V54.0653H147.976V50.7109Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 50.7109H149.745V54.0653H151.35V50.7109Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 50.7109H153.119V54.0653H154.725V50.7109Z",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 50.7109H156.493V54.0653H158.099V50.7109Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 55.4023H142.996V58.7567H144.602V55.4023Z",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 55.4023H146.37V58.7567H147.976V55.4023Z",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 55.4023H149.745V58.7567H151.35V55.4023Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 55.4023H153.119V58.7567H154.725V55.4023Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 55.4023H156.493V58.7567H158.099V55.4023Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 60.0938H142.996V63.4481H144.602V60.0938Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 60.0938H146.37V63.4481H147.976V60.0938Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 60.0938H149.745V63.4481H151.35V60.0938Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 60.0938H153.119V63.4481H154.725V60.0938Z",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 60.0938H156.493V63.4481H158.099V60.0938Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 64.7861H142.996V68.1405H144.602V64.7861Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 64.7861H146.37V68.1405H147.976V64.7861Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 64.7861H149.745V68.1405H151.35V64.7861Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 64.7861H153.119V68.1405H154.725V64.7861Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 64.7861H156.493V68.1405H158.099V64.7861Z",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 69.4775H142.996V72.8322H144.602V69.4775Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 69.4775H146.37V72.8322H147.976V69.4775Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 69.4775H149.745V72.8322H151.35V69.4775Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 69.4775H153.119V72.8322H154.725V69.4775Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 69.4775H156.493V72.8322H158.099V69.4775Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 74.1689H142.996V77.5233H144.602V74.1689Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 74.1689H146.37V77.5233H147.976V74.1689Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 74.1689H149.745V77.5233H151.35V74.1689Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 74.1689H153.119V77.5233H154.725V74.1689Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 74.1689H156.493V77.5233H158.099V74.1689Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 78.8613H142.996V82.2157H144.602V78.8613Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 78.8613H146.37V82.2157H147.976V78.8613Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 78.8613H149.745V82.2157H151.35V78.8613Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 78.8613H153.119V82.2157H154.725V78.8613Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 78.8613H156.493V82.2157H158.099V78.8613Z",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M144.602 83.293H142.996V86.6473H144.602V83.293Z",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M147.976 83.293H146.37V86.6473H147.976V83.293Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 83.293H149.745V86.6473H151.35V83.293Z",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 83.293H153.119V86.6473H154.725V83.293Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 83.293H156.493V86.6473H158.099V83.293Z",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M167.438 25.0625H159.562V88.523H167.438V25.0625Z",
    fill: "#E0E0E0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 27.252H149.745V30.6063H151.35V27.252Z",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 27.252H153.119V30.6063H154.725V27.252Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 27.252H156.493V30.6063H158.099V27.252Z",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 31.9443H149.745V35.2987H151.35V31.9443Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 31.9443H153.119V35.2987H154.725V31.9443Z",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 31.9443H156.493V35.2987H158.099V31.9443Z",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 36.6357H149.745V39.9901H151.35V36.6357Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 36.6357H153.119V39.9901H154.725V36.6357Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 36.6357H156.493V39.9901H158.099V36.6357Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 41.3271H149.745V44.6815H151.35V41.3271Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 41.3271H153.119V44.6815H154.725V41.3271Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 41.3271H156.493V44.6815H158.099V41.3271Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 46.0195H149.745V49.3739H151.35V46.0195Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 46.0195H153.119V49.3739H154.725V46.0195Z",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 46.0195H156.493V49.3739H158.099V46.0195Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 50.7109H149.745V54.0653H151.35V50.7109Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 50.7109H153.119V54.0653H154.725V50.7109Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 50.7109H156.493V54.0653H158.099V50.7109Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 55.4023H149.745V58.7567H151.35V55.4023Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 55.4023H153.119V58.7567H154.725V55.4023Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 55.4023H156.493V58.7567H158.099V55.4023Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 60.0947H149.745V63.4491H151.35V60.0947Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 60.0947H153.119V63.4491H154.725V60.0947Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 60.0947H156.493V63.4491H158.099V60.0947Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 64.7861H149.745V68.1405H151.35V64.7861Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 64.7861H153.119V68.1405H154.725V64.7861Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 64.7861H156.493V68.1405H158.099V64.7861Z",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 69.4775H149.745V72.8322H151.35V69.4775Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 69.4775H153.119V72.8322H154.725V69.4775Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 69.4775H156.493V72.8322H158.099V69.4775Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 74.1689H149.745V77.5233H151.35V74.1689Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 74.1689H153.119V77.5233H154.725V74.1689Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 74.1689H156.493V77.5233H158.099V74.1689Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 78.8613H149.745V82.2157H151.35V78.8613Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 78.8613H153.119V82.2157H154.725V78.8613Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 78.8613H156.493V82.2157H158.099V78.8613Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 83.2939H149.745V86.6483H151.35V83.2939Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M154.725 83.2939H153.119V86.6483H154.725V83.2939Z",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M158.099 83.2939H156.493V86.6483H158.099V83.2939Z",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 27.252H161.345V30.6063H162.95V27.252Z",
    fill: "#EBEBEB"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 27.252H164.719V30.6063H166.325V27.252Z",
    fill: "#EBEBEB"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 31.9443H161.345V35.2987H162.95V31.9443Z",
    fill: "#EBEBEB"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 31.9443H164.719V35.2987H166.325V31.9443Z",
    fill: "#EBEBEB"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 36.6357H161.345V39.9901H162.95V36.6357Z",
    fill: "#EBEBEB"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 36.6357H164.719V39.9901H166.325V36.6357Z",
    fill: "#EBEBEB"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 41.3271H161.345V44.6815H162.95V41.3271Z",
    fill: "#EBEBEB"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 41.3271H164.719V44.6815H166.325V41.3271Z",
    fill: "#EBEBEB"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 46.0195H161.345V49.3739H162.95V46.0195Z",
    fill: "#EBEBEB"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 46.0195H164.719V49.3739H166.325V46.0195Z",
    fill: "#EBEBEB"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 50.7109H161.345V54.0653H162.95V50.7109Z",
    fill: "#EBEBEB"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 50.7109H164.719V54.0653H166.325V50.7109Z",
    fill: "#EBEBEB"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 55.4023H161.345V58.7567H162.95V55.4023Z",
    fill: "#EBEBEB"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 55.4023H164.719V58.7567H166.325V55.4023Z",
    fill: "#EBEBEB"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 60.0947H161.345V63.4491H162.95V60.0947Z",
    fill: "#EBEBEB"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 60.0947H164.719V63.4491H166.325V60.0947Z",
    fill: "#EBEBEB"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 64.7861H161.345V68.1405H162.95V64.7861Z",
    fill: "#EBEBEB"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 64.7861H164.719V68.1405H166.325V64.7861Z",
    fill: "#EBEBEB"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 69.4775H161.345V72.8322H162.95V69.4775Z",
    fill: "#EBEBEB"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 69.4775H164.719V72.8322H166.325V69.4775Z",
    fill: "#EBEBEB"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 74.1689H161.345V77.5233H162.95V74.1689Z",
    fill: "#EBEBEB"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 74.1689H164.719V77.5233H166.325V74.1689Z",
    fill: "#EBEBEB"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 78.8613H161.345V82.2157H162.95V78.8613Z",
    fill: "#EBEBEB"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 78.8613H164.719V82.2157H166.325V78.8613Z",
    fill: "#EBEBEB"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M162.95 83.2939H161.345V86.6483H162.95V83.2939Z",
    fill: "#EBEBEB"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 83.2939H164.719V86.6483H166.325V83.2939Z",
    fill: "#EBEBEB"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M182.402 39.9551C182.475 39.9551 182.534 41.4584 182.534 43.3126C182.534 45.1673 182.475 46.6704 182.402 46.6704C182.329 46.6704 182.27 45.1673 182.27 43.3126C182.27 41.4584 182.329 39.9551 182.402 39.9551Z",
    fill: "#E0E0E0"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M189.142 47.1924L170.241 52.5077V88.5227H189.142V47.1924Z",
    fill: "#E0E0E0"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M173.076 51.6904V45.3037H184.712V48.4181L173.076 51.6904Z",
    fill: "#E0E0E0"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M171.682 52.866L171.831 85.9834H187.206V48.4971L171.682 52.866Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M175.839 86.738C175.766 86.738 175.707 78.7909 175.707 68.99C175.707 59.1856 175.766 51.2402 175.839 51.2402C175.912 51.2402 175.971 59.1856 175.971 68.99C175.971 78.7909 175.912 86.738 175.839 86.738Z",
    fill: "#E0E0E0"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M182.301 86.7378C182.228 86.7378 182.169 78.3481 182.169 68.0011C182.169 57.6507 182.228 49.2627 182.301 49.2627C182.374 49.2627 182.433 57.6507 182.433 68.0011C182.433 78.3481 182.374 86.7378 182.301 86.7378Z",
    fill: "#E0E0E0"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M188.267 57.9221C188.267 57.9943 184.438 58.0531 179.717 58.0531C174.994 58.0531 171.166 57.9946 171.166 57.9221C171.166 57.8498 174.994 57.791 179.717 57.791C184.438 57.791 188.267 57.8498 188.267 57.9221Z",
    fill: "#E0E0E0"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M188.107 68.0568C188.107 68.1291 184.279 68.1879 179.557 68.1879C174.834 68.1879 171.007 68.1291 171.007 68.0568C171.007 67.9845 174.834 67.9258 179.557 67.9258C184.279 67.9258 188.107 67.9845 188.107 68.0568Z",
    fill: "#E0E0E0"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M189.066 78.2717C189.066 78.3439 185.095 78.4027 180.196 78.4027C175.297 78.4027 171.326 78.3439 171.326 78.2717C171.326 78.1994 175.297 78.1406 180.196 78.1406C185.095 78.1406 189.066 78.1991 189.066 78.2717Z",
    fill: "#E0E0E0"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M189.07 47.1925C189.091 47.2622 184.907 48.4995 179.728 49.9559C174.547 51.4129 170.333 52.5372 170.313 52.4675C170.293 52.3981 174.475 51.1609 179.656 49.7039C184.835 48.2475 189.051 47.1228 189.07 47.1925Z",
    fill: "#E0E0E0"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M176.703 65.491C176.651 65.4398 177.581 64.4358 178.779 63.2487C179.977 62.0612 180.99 61.1405 181.042 61.1915C181.094 61.2424 180.164 62.2464 178.966 63.4338C177.768 64.621 176.755 65.542 176.703 65.491Z",
    fill: "#E0E0E0"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M179.592 61.4149C179.643 61.4673 179.308 61.8639 178.845 62.3005C178.382 62.7374 177.965 63.0488 177.915 62.9963C177.865 62.9439 178.199 62.5476 178.663 62.1107C179.126 61.6741 179.542 61.3625 179.592 61.4149Z",
    fill: "#E0E0E0"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M180.658 72.8802C180.71 72.9309 179.917 73.8154 178.886 74.8556C177.854 75.8962 176.976 76.6982 176.924 76.6476C176.872 76.5969 177.665 75.7127 178.697 74.6722C179.728 73.6316 180.606 72.8293 180.658 72.8802Z",
    fill: "#E0E0E0"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M179.208 73.3294C179.262 73.3778 178.998 73.7542 178.619 74.1701C178.24 74.586 177.888 74.8838 177.834 74.8351C177.78 74.7864 178.044 74.4103 178.423 73.9944C178.802 73.5786 179.153 73.2808 179.208 73.3294Z",
    fill: "#E0E0E0"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M185.736 52.8733C185.792 52.9203 185.397 53.4681 184.855 54.0968C184.313 54.7255 183.829 55.1969 183.773 55.15C183.718 55.103 184.112 54.5553 184.654 53.9266C185.196 53.2979 185.681 52.8264 185.736 52.8733Z",
    fill: "#E0E0E0"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M185.296 52.2081C185.35 52.2568 185.07 52.6505 184.67 53.0873C184.271 53.5245 183.903 53.8393 183.848 53.7906C183.794 53.7423 184.075 53.3486 184.475 52.9114C184.874 52.4745 185.242 52.1594 185.296 52.2081Z",
    fill: "#E0E0E0"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M174.419 81.8587C174.479 81.9004 174.237 82.3396 173.88 82.8396C173.522 83.3396 173.185 83.7108 173.125 83.669C173.065 83.6273 173.306 83.1881 173.664 82.6881C174.021 82.1881 174.36 81.8169 174.419 81.8587Z",
    fill: "#E0E0E0"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M173.962 81.2557C174.016 81.3053 173.803 81.6154 173.488 81.9487C173.173 82.2819 172.874 82.512 172.82 82.4625C172.767 82.4129 172.98 82.1027 173.295 81.7695C173.61 81.4363 173.909 81.2062 173.962 81.2557Z",
    fill: "#E0E0E0"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M121.507 22.1155C121.27 21.4879 121.027 20.8514 120.628 20.3103C120.229 19.7691 119.646 19.3259 118.975 19.2444C118.303 19.1629 117.559 19.522 117.341 20.1562C117.245 18.7271 117.04 17.2609 116.318 16.0202C115.596 14.7795 114.249 13.8046 112.806 13.8922C111.446 13.9746 110.281 14.9759 109.634 16.1642C108.987 17.3528 108.765 18.7159 108.552 20.0499C108.037 19.4229 106.948 19.6199 106.409 20.2282C105.871 20.8364 105.735 21.6863 105.621 22.4873H121.535L121.507 22.1155Z",
    fill: "#F5F5F5"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M199.331 28.4895C199.094 27.8619 198.852 27.2254 198.453 26.6843C198.053 26.1431 197.47 25.6999 196.799 25.6184C196.127 25.5369 195.384 25.896 195.165 26.5302C195.069 25.1012 194.865 23.6349 194.143 22.3942C193.421 21.1535 192.074 20.1787 190.631 20.2662C189.27 20.3486 188.105 21.35 187.458 22.5382C186.811 23.7268 186.589 25.0899 186.376 26.4239C185.861 25.797 184.772 25.994 184.234 26.6022C183.695 27.2105 183.559 28.0604 183.445 28.8613H199.359L199.331 28.4895Z",
    fill: "#F5F5F5"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M180.584 20.4117C180.44 20.0307 180.293 19.6442 180.051 19.3156C179.809 18.9869 179.455 18.7177 179.047 18.6684C178.639 18.6192 178.188 18.8369 178.055 19.222C177.996 18.3542 177.872 17.464 177.434 16.7106C176.995 15.9572 176.178 15.3653 175.301 15.4183C174.475 15.4685 173.768 16.0764 173.375 16.7981C172.982 17.5199 172.847 18.3476 172.718 19.1577C172.405 18.777 171.744 18.8965 171.417 19.266C171.09 19.6352 171.007 20.1516 170.938 20.6378H180.601L180.584 20.4117Z",
    fill: "#EBEBEB"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9506 15.076C96.8064 14.695 96.6596 14.3085 96.4172 13.9799C96.1748 13.6513 95.8207 13.382 95.4132 13.3328C95.0054 13.2832 94.5537 13.5013 94.4209 13.8863C94.3625 13.0186 94.2383 12.1284 93.8 11.3747C93.3617 10.6212 92.5438 10.0294 91.6674 10.0824C90.8413 10.1325 90.1341 10.7405 89.7411 11.4622C89.3482 12.1839 89.2133 13.0117 89.0842 13.8218C88.7712 13.4411 88.1099 13.5609 87.7832 13.9301C87.4565 14.2993 87.3737 14.8154 87.3042 15.3018H96.9674L96.9506 15.076Z",
    fill: "#EBEBEB"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8734 28.3242C28.6972 27.8585 28.5179 27.3862 28.2217 26.9848C27.9255 26.5833 27.4927 26.2544 26.9945 26.1939C26.4963 26.1334 25.9443 26.3998 25.7818 26.8704C25.7103 25.81 25.5586 24.7219 25.0229 23.8012C24.4872 22.8805 23.4876 22.157 22.4168 22.2218C21.4073 22.2829 20.5429 23.0259 20.0627 23.9081C19.5825 24.7899 19.4174 25.8017 19.2599 26.7915C18.8771 26.3261 18.069 26.4724 17.6696 26.9237C17.2703 27.375 17.1691 28.0057 17.0842 28.6001H28.8937L28.8734 28.3242Z",
    fill: "#EBEBEB"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5564 122.961H25.9072L31.3642 121.497H99.0134L93.5564 122.961Z",
    fill: "#EBEBEB"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M185.33 122.961H117.68L123.137 121.497H190.787L185.33 122.961Z",
    fill: "#EBEBEB"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M213.64 88.738C213.64 88.7794 166.787 88.8129 109.005 88.8129C51.2028 88.8129 4.36011 88.7792 4.36011 88.738C4.36011 88.6965 51.2028 88.6631 109.005 88.6631C166.787 88.6631 213.64 88.6968 213.64 88.738Z",
    fill: "#263238"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 115.636C28.1607 115.282 81.0417 113.054 82.1282 113.67C83.2147 114.286 193.072 109.553 192.317 109.553C191.563 109.553 188.962 96.657 188.962 96.657C188.962 96.657 178.447 88.9879 177.464 88.1867C176.48 87.3854 49.7802 87.5309 49.0259 88.3298C48.2717 89.1287 27.3 98.3447 27.3 98.3447V115.636Z",
    fill: "#0F538D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3 115.636C28.1607 115.282 81.0417 113.054 82.1282 113.67C83.2147 114.286 193.072 109.553 192.317 109.553C191.563 109.553 188.962 96.657 188.962 96.657C188.962 96.657 178.447 88.9879 177.464 88.1867C176.48 87.3854 49.7802 87.5309 49.0259 88.3298C48.2717 89.1287 27.3 98.3447 27.3 98.3447V115.636Z",
    fill: "black"
  }))), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M182.414 62.5382L195.769 74.6884L189.779 76.232L184.563 72.5952L177.464 65.8954L179.927 62.0195L182.414 62.5382Z",
    fill: "#455A64"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6113 77.573C62.6113 77.573 85.7798 62.7747 94.0251 60.373L96.4324 61.4962L92.5535 64.7354L64.0795 79.3445L62.6113 77.573Z",
    fill: "#455A64"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M199.29 89.7253L197.104 85.5148L198.197 83.8306V77.6953L195.769 74.6877L191.277 74.0861L179.985 63.7403L182.414 62.5373L183.021 61.0938L182.292 59.7705C167.844 57.124 126.321 56.5224 115.516 56.402C104.71 56.2816 94.0253 60.3718 94.0253 60.3718L94.9968 61.2139C94.9968 61.2139 90.5045 63.3794 84.1909 66.3867C77.8774 69.3943 65.0078 77.8151 65.0078 77.8151L60.2728 77.3339C35.8688 79.1385 25.9131 84.0705 22.7562 85.5142C19.5996 86.9577 15.8357 95.7397 15.8357 95.7397C14.8643 97.8245 16.5641 108.852 16.5641 108.852C16.5641 108.852 26.6413 113.544 27.0058 113.544C27.0854 113.544 29.0058 113.509 31.9578 113.455C31.8079 112.522 31.7279 111.565 31.7279 110.589C31.7279 100.584 39.9137 92.4737 50.0112 92.4737C60.1086 92.4737 68.2944 100.584 68.2944 110.589C68.2944 111.337 68.2432 112.073 68.1543 112.797L131.906 111.98L151.098 109.906C151.461 100.218 159.497 92.4734 169.364 92.4734C176.83 92.4734 183.252 96.9081 186.091 103.264C186.486 104.148 186.808 105.069 187.058 106.02L197.59 104.882L200.626 101.153L199.29 89.7253Z",
    fill: "#0F538D"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 108.203C15.5356 108.203 16.1899 112.568 17.286 113.545C18.3821 114.522 28.3471 117.089 30.2405 117.188C32.1339 117.287 32.9783 117.188 32.9783 117.188L31.7275 109.19L15.5356 108.203Z",
    fill: "#263238"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1104 108.203C67.1104 108.302 68.3076 117.232 68.3076 117.232L150.552 114.621L152.063 105.537L67.1104 108.203Z",
    fill: "#263238"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4761 105.187C71.4723 105.139 75.5442 103.058 81.3521 102.364C87.1602 101.671 135.933 99.1058 139.152 99.5219C142.371 99.9378 147.129 101.949 147.129 101.949L71.4761 105.187Z",
    fill: "black"
  }))), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M118.012 115.635C118.009 115.635 118.007 115.601 118.005 115.533C118.003 115.458 118.001 115.358 117.998 115.233C117.995 114.96 117.991 114.573 117.987 114.079C117.983 113.069 117.979 111.621 117.973 109.837C117.977 106.247 117.981 101.303 117.987 95.8415C117.982 94.4744 118.029 93.1323 118.161 91.8499C118.276 90.5645 118.425 89.329 118.58 88.1542C118.893 85.8047 119.23 83.6974 119.523 81.9297C119.825 80.1706 120.07 78.7438 120.241 77.7474C120.323 77.2606 120.388 76.8793 120.434 76.6103C120.458 76.4804 120.466 76.3811 120.477 76.3143C120.486 76.2475 120.492 76.2129 120.495 76.2129C120.497 76.2129 120.496 76.2475 120.492 76.3148C120.487 76.3822 120.483 76.4839 120.464 76.6144C120.432 76.8764 120.376 77.2615 120.299 77.7566C120.139 78.7548 119.911 80.1841 119.628 81.9464C119.349 83.7156 119.024 85.8237 118.719 88.1718C118.567 89.346 118.421 90.5801 118.309 91.8625C118.179 93.1456 118.134 94.4738 118.138 95.8401C118.115 101.302 118.095 106.247 118.08 109.837C118.066 111.622 118.054 113.069 118.045 114.08C118.038 114.573 118.032 114.96 118.028 115.233C118.025 115.359 118.022 115.458 118.02 115.533C118.017 115.601 118.015 115.635 118.012 115.635Z",
    fill: "#263238"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.789 86.1519C35.453 86.2524 70.6998 85.4644 76.9131 84.6243C83.1264 83.7842 183.87 79.7168 183.87 79.7168C183.87 79.7168 47.5497 82.6339 35.789 86.1519Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.962 86.6374C188.962 86.6374 190.72 90.6901 192.676 91.0855C194.632 91.481 199.29 89.7262 199.29 89.7262L197.104 85.5156L188.962 86.6374Z",
    fill: "black"
  }))), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M183.47 80.3427C183.512 80.7755 188.088 86.3898 188.962 86.6372C189.836 86.8846 195.294 86.5548 195.769 86.3486C196.244 86.1424 197.105 85.5155 197.105 85.5155L198.197 83.8312C198.197 83.8312 198.403 79.612 198.197 79.6616C197.991 79.7111 183.386 79.4902 183.47 80.3427Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4021 88.1861C22.401 88.1838 22.4361 88.1648 22.5065 88.1311C22.5835 88.0951 22.6873 88.047 22.8198 87.9854C23.0962 87.859 23.5067 87.6793 24.038 87.4537C25.1021 87.0068 26.6505 86.3775 28.6 85.6952C29.5752 85.356 30.6486 84.9965 31.8162 84.6593C32.983 84.3203 34.2404 83.9906 35.5879 83.7429C38.2818 83.274 41.2623 82.8973 44.3919 82.52C50.6552 81.7819 56.3363 81.2197 60.4489 80.8249C62.5002 80.6368 64.1628 80.4841 65.3214 80.3779C65.8908 80.3304 66.3358 80.2932 66.6471 80.2673C66.793 80.2569 66.9073 80.2489 66.9924 80.2428C67.0703 80.2382 67.1101 80.237 67.1104 80.2396C67.1107 80.2422 67.0712 80.2486 66.9939 80.2581C66.9093 80.2679 66.7954 80.2808 66.65 80.2975C66.3393 80.3301 65.8952 80.3764 65.3269 80.436C64.1695 80.5536 62.5086 80.7223 60.4594 80.9305C56.3497 81.3522 50.6712 81.9314 44.4097 82.6689C41.2818 83.0459 38.3013 83.4186 35.6126 83.8788C34.2727 84.1213 33.017 84.4456 31.8514 84.7788C30.685 85.1097 29.6115 85.4631 28.6355 85.7954C26.6839 86.4639 25.1309 87.0776 24.0607 87.5076C23.5331 87.7248 23.1207 87.8944 22.8323 88.013C22.6974 88.0689 22.5916 88.1127 22.5129 88.1452C22.4405 88.1743 22.4033 88.1884 22.4021 88.1861Z",
    fill: "#263238"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1563 88.2917C22.0456 88.3436 18.5968 92.8916 19.0613 93.3902C19.5255 93.8884 24.9421 94.0036 26.8378 92.9685C28.7335 91.9335 35.5427 86.4134 35.5816 86.1836C35.6203 85.9534 24.9421 86.9885 22.1563 88.2917Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 99.6761C15.5728 99.6807 22.5651 98.6425 24.2571 100.111C25.9488 101.58 26.7307 107.542 26.5528 108.203C26.3749 108.864 16.4597 108.146 16.4678 108.203C16.4719 108.231 16.1722 106.189 15.9434 104.098C15.7042 101.914 15.5356 99.6761 15.5356 99.6761Z",
    fill: "black"
  }))), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5369 100.002C18.4218 100.249 19.2507 105.551 20.1291 106.313C21.0075 107.074 26.2785 107.238 26.2785 107.238C26.2785 107.238 25.3635 101.275 24.2572 100.438C23.1506 99.6003 18.8662 99.2953 18.5369 100.002Z",
    fill: "#263238"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M100.333 58.524C100.333 58.524 102.638 57.0702 106.633 55.6149C110.627 54.1597 127.122 54.1597 135.628 54.3063C144.135 54.4529 163.219 54.4315 167.435 55.6149C171.651 56.7983 174.683 58.7654 174.683 58.7654L170.981 58.4618C170.981 58.4618 167.326 56.4006 159.521 56.2851C155.379 56.2238 113.66 55.9188 111.441 56.2851C109.222 56.6517 107.31 57.1857 107.31 57.1857L100.333 58.524Z",
    fill: "#E0E0E0"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M100.333 58.5239C100.553 58.4807 102.786 58.0421 107.304 57.1548L107.301 57.1553C107.975 56.9701 108.703 56.7939 109.484 56.6228C109.874 56.5381 110.277 56.4561 110.694 56.3777C110.903 56.3406 111.114 56.3026 111.329 56.2643C111.544 56.2277 111.767 56.2262 111.991 56.2055C112.441 56.1658 112.898 56.1715 113.369 56.1517C113.84 56.1352 114.322 56.1277 114.815 56.1208C115.802 56.1033 116.833 56.0906 117.907 56.0837C122.204 56.0485 127.183 56.0462 132.707 56.0569C138.231 56.0817 144.3 56.109 150.774 56.1378C152.393 56.1499 154.036 56.162 155.704 56.1741C156.537 56.1816 157.377 56.1888 158.222 56.1963C158.644 56.2012 159.068 56.2061 159.493 56.2107C159.919 56.2234 160.346 56.2363 160.775 56.2493C162.487 56.327 164.219 56.4929 165.944 56.8244C166.807 56.9799 167.665 57.1916 168.517 57.439C169.367 57.6953 170.211 57.9819 171.018 58.3957L170.987 58.3862C172.159 58.4824 173.42 58.5855 174.688 58.6895L174.641 58.8269C174.516 58.7477 174.376 58.6624 174.236 58.5804C173.119 57.9269 171.959 57.3601 170.779 56.8653C169.597 56.3769 168.397 55.9382 167.174 55.6335C165.951 55.3429 164.69 55.2456 163.452 55.1246C162.21 55.0224 160.975 54.9469 159.751 54.8821C154.851 54.6457 150.118 54.5685 145.61 54.5003C141.101 54.4401 136.817 54.383 132.807 54.3295C128.798 54.2848 125.063 54.2978 121.654 54.3586C118.245 54.4251 115.162 54.5435 112.463 54.7528C111.112 54.8496 109.861 54.9973 108.715 55.1644C108.43 55.2185 108.152 55.2712 107.881 55.3231C107.745 55.3513 107.609 55.3703 107.479 55.4052C107.349 55.442 107.221 55.4786 107.094 55.5149C106.584 55.6433 106.119 55.8423 105.673 56.0079C103.898 56.6954 102.563 57.3333 101.672 57.7915C101.227 58.0208 100.893 58.2051 100.669 58.3312C100.446 58.4585 100.333 58.5239 100.333 58.5239C100.333 58.5239 100.442 58.449 100.662 58.3189C100.883 58.1884 101.216 57.9995 101.659 57.7656C102.545 57.2982 103.878 56.6513 105.652 55.9544C106.098 55.7862 106.56 55.5857 107.076 55.4533C107.203 55.4164 107.332 55.3789 107.463 55.3409C107.594 55.3055 107.73 55.2856 107.866 55.2568C108.139 55.2038 108.418 55.1497 108.703 55.0944C109.852 54.9228 111.105 54.7707 112.456 54.6699C115.158 54.4522 118.242 54.3266 121.652 54.2532C125.062 54.1858 128.798 54.1665 132.808 54.2056C136.818 54.2549 141.103 54.3073 145.612 54.3626C150.121 54.4271 154.855 54.5014 159.759 54.7358C160.984 54.8004 162.221 54.8749 163.466 54.9772C164.708 55.0987 165.967 55.1941 167.212 55.4893C168.446 55.7968 169.65 56.2366 170.838 56.7277C172.024 57.225 173.19 57.7938 174.314 58.4519C174.455 58.5349 174.595 58.6201 174.724 58.7019L174.981 58.8643L174.676 58.8393C173.408 58.7353 172.147 58.6319 170.975 58.5357L170.96 58.5346L170.943 58.5262C170.162 58.125 169.315 57.8353 168.474 57.5821C167.628 57.3365 166.775 57.1257 165.915 56.9707C164.2 56.6404 162.474 56.4745 160.768 56.3965C160.341 56.3835 159.915 56.3705 159.491 56.3576C159.066 56.3527 158.642 56.3475 158.22 56.3426C157.375 56.3348 156.536 56.3268 155.702 56.319C154.035 56.3057 152.391 56.2925 150.773 56.2795C144.299 56.2438 138.231 56.2107 132.707 56.1802C127.183 56.1617 122.204 56.1551 117.908 56.1799C116.834 56.1842 115.803 56.1943 114.816 56.2093C114.323 56.2147 113.841 56.2211 113.371 56.236C112.902 56.2542 112.44 56.2476 111.998 56.2853C111.776 56.3054 111.556 56.3052 111.342 56.3412C111.128 56.3786 110.916 56.4157 110.708 56.4523C110.292 56.5292 109.889 56.6099 109.499 56.6928C108.719 56.8604 107.99 57.0338 107.318 57.2155L107.317 57.2158L107.316 57.2161C102.791 58.0637 100.553 58.4827 100.333 58.5239Z",
    fill: "#263238"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M185.978 113.545C186.783 113.455 185.835 103.417 185.388 103.439C185.054 103.455 199.914 100.432 200.545 100.464C201.236 100.499 201.436 101.192 201.309 100.907C201.309 100.907 202.882 105.95 202.358 107.226C201.833 108.502 191.023 113.265 190.171 113.545C189.319 113.826 185.978 113.545 185.978 113.545Z",
    fill: "#263238"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M160.272 94.9453C160.27 94.9447 160.275 94.9133 160.288 94.8528C160.303 94.7846 160.323 94.6964 160.348 94.5853C160.406 94.341 160.488 93.9975 160.592 93.5597C160.808 92.66 161.118 91.3746 161.499 89.7904C161.878 88.1983 162.33 86.3021 162.793 84.189C163.017 83.1324 163.269 82.021 163.427 80.8621C163.443 80.7192 163.46 80.5683 163.452 80.4364C163.455 80.3756 163.419 80.3068 163.392 80.2403L163.309 80.039C163.182 79.7685 163.054 79.4958 162.925 79.221C162.656 78.675 162.384 78.1209 162.108 77.5599C159.875 73.0838 157.809 69.0526 156.327 66.1283C155.59 64.6724 154.992 63.4913 154.573 62.6645C154.372 62.2613 154.215 61.9448 154.103 61.7199C154.053 61.617 154.014 61.5355 153.983 61.4725C153.957 61.4163 153.945 61.3869 153.947 61.3858C153.95 61.3846 153.966 61.4117 153.997 61.4656C154.031 61.5269 154.074 61.6061 154.13 61.706C154.248 61.9278 154.414 62.24 154.626 62.638C155.054 63.4597 155.667 64.6333 156.422 66.0802C157.928 68.9924 160.009 73.0158 162.244 77.4936C162.52 78.0549 162.792 78.6099 163.061 79.1568C163.191 79.4333 163.319 79.7075 163.447 79.9796L163.534 80.1933C163.561 80.2653 163.599 80.3301 163.6 80.4211C163.61 80.5856 163.59 80.7302 163.574 80.8791C163.412 82.0535 163.157 83.1597 162.929 84.2184C162.458 86.3318 161.996 88.2256 161.603 89.8151C161.21 91.4043 160.881 92.6879 160.649 93.5738C160.533 94.0087 160.442 94.3503 160.378 94.5928C160.347 94.7025 160.322 94.7895 160.303 94.8568C160.285 94.9159 160.275 94.9461 160.272 94.9453Z",
    fill: "#263238"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7939 80.3426C67.0204 80.2573 88.3864 64.5504 98.3804 62.5868C108.374 60.6235 118.454 59.8551 128.534 60.1111C138.614 60.3672 169.027 62.2452 169.027 62.2452L174.196 67.7086L161.618 75.306L66.7939 80.3426Z",
    fill: "#455A64"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3805 62.5868C93.2433 63.596 85.1011 68.2371 78.3699 72.5208C84.4134 71.452 106.429 67.8428 118.537 66.9679C132.504 65.9587 173.495 66.9679 173.495 66.9679L169.027 62.2452C169.027 62.2452 138.614 60.3672 128.534 60.1112C118.455 59.8551 108.375 60.6232 98.3805 62.5868Z",
    fill: "white"
  }))), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M120.495 60.373L115.326 77.7818L124.712 77.2657L125.836 60.373H120.495Z",
    fill: "#263238"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M155.134 75.668C155.331 75.4733 156.183 67.6829 156.183 67.6829C156.183 67.6829 152.645 61.3857 152.841 61.3857C153.038 61.3857 155.528 61.3857 155.528 61.3857C155.528 61.3857 162.276 75.2783 162.145 75.2783C162.014 75.2783 155.134 75.668 155.134 75.668Z",
    fill: "#263238"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7939 80.6308C66.6573 80.6308 66.5382 80.536 66.5097 80.4024C66.4826 80.2751 66.5451 80.1469 66.6588 80.0879C66.7201 80.0493 67.0201 79.8373 67.3974 79.5712C81.7578 69.429 92.452 63.4582 98.3243 62.3045C108.04 60.3956 118.206 59.5607 128.542 59.8236C138.512 60.0768 168.741 61.9393 169.046 61.9583C169.119 61.9629 169.189 61.9952 169.239 62.0487L174.409 67.5121C174.469 67.5754 174.496 67.6618 174.485 67.748C174.473 67.8338 174.423 67.9101 174.348 67.955L161.77 75.5522C161.728 75.5772 161.682 75.5914 161.634 75.5942L66.8099 80.6305C66.8044 80.6308 66.7992 80.6308 66.7939 80.6308ZM124.835 60.3524C115.815 60.3524 106.952 61.1968 98.4371 62.8695C92.7351 63.9899 81.8528 70.073 67.7895 80.0015L161.529 75.0226L173.74 67.6474L168.894 62.5259C166.832 62.3992 138.174 60.6444 128.527 60.3994C127.294 60.3683 126.063 60.3524 124.835 60.3524Z",
    fill: "#E0E0E0"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3984 117.1C72.3957 117.1 72.3905 117.064 72.3824 116.994C72.3745 116.916 72.3638 116.813 72.3504 116.682C72.3248 116.398 72.2885 115.994 72.2423 115.479C72.1548 114.425 72.0292 112.914 71.8743 111.052C71.5714 107.313 71.1648 102.148 70.7384 96.4413C70.4794 92.9352 70.2343 89.6338 70.0652 86.7397C70.0541 86.376 70.0158 86.0214 70.0562 85.6643C70.0986 85.3127 70.1727 84.9754 70.2599 84.6503C70.4358 84.0002 70.6491 83.3931 70.8671 82.8241C71.3052 81.6856 71.7496 80.6911 72.1533 79.8487L72.1504 79.8571C72.4408 78.7103 72.6713 77.8008 72.8312 77.1686C72.9108 76.8642 72.973 76.6266 73.0175 76.4569C73.0384 76.3818 73.055 76.3219 73.0683 76.2746C73.0806 76.2338 73.0875 76.2133 73.0896 76.2139C73.0916 76.2145 73.0884 76.2358 73.08 76.2775C73.0698 76.3256 73.0567 76.3864 73.0407 76.4624C73.0015 76.6332 72.9466 76.8725 72.8762 77.1793C72.7254 77.8134 72.5085 78.7261 72.2347 79.8769L72.2338 79.881L72.2318 79.8856C71.8382 80.7291 71.4025 81.7265 70.9735 82.8635C70.7599 83.432 70.5515 84.0377 70.3805 84.6817C70.296 85.0036 70.2248 85.3366 70.1849 85.6778C70.1474 86.0162 70.1864 86.3734 70.1989 86.7331C70.3791 89.6234 70.6308 92.9251 70.8895 96.4309C71.3156 102.134 71.701 107.297 71.9812 111.045C72.1158 112.909 72.2251 114.42 72.3013 115.475C72.3356 115.991 72.3623 116.396 72.3812 116.68C72.3882 116.812 72.394 116.916 72.3981 116.994C72.4007 117.064 72.401 117.1 72.3984 117.1Z",
    fill: "#263238"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5945 113.379L148.696 111.122L147.332 112.788L73.9989 115.114L71.5945 113.379Z",
    fill: "black"
  }))), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4889 110.48C66.8551 101.615 59.899 94.1347 50.9519 93.7718C42.0048 93.4089 34.4549 100.301 34.0887 109.166C33.7224 118.031 40.6786 125.512 49.6257 125.875C58.5727 126.238 66.1227 119.345 66.4889 110.48Z",
    fill: "#263238"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0757 109.552C34.0754 109.566 34.0731 109.579 34.0728 109.593C33.9437 118.464 41.097 125.76 50.0504 125.887C59.0038 126.015 66.3667 118.928 66.4958 110.057C66.496 110.043 66.4943 110.029 66.4943 110.015L34.0757 109.552Z",
    fill: "#263238"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9031 109.662C38.8124 115.891 43.8345 121.012 50.1202 121.102C56.4061 121.192 61.5754 116.216 61.666 109.988C61.7567 103.76 56.7346 98.6376 50.4486 98.5481C44.1627 98.4579 38.9938 103.434 38.9031 109.662Z",
    fill: "#FAFAFA"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4486 98.5471C44.1627 98.4572 38.9938 103.433 38.9031 109.662L61.6661 109.987C61.7567 103.759 56.7346 98.637 50.4486 98.5471Z",
    fill: "#E0E0E0"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3513 109.725C43.2961 113.519 46.3554 116.639 50.1843 116.694C54.0133 116.749 57.1623 113.717 57.2176 109.924C57.2728 106.129 54.2132 103.01 50.3843 102.955C46.5553 102.9 43.4065 105.931 43.3513 109.725Z",
    fill: "#263238"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M185.281 110.48C185.647 101.615 178.691 94.1347 169.744 93.7718C160.797 93.4089 153.247 100.301 152.88 109.166C152.514 118.031 159.47 125.512 168.417 125.875C177.364 126.238 184.914 119.345 185.281 110.48Z",
    fill: "#263238"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M152.86 109.552C152.86 109.566 152.857 109.579 152.857 109.593C152.728 118.464 159.881 125.76 168.835 125.887C177.788 126.015 185.151 118.928 185.28 110.057C185.28 110.043 185.279 110.029 185.279 110.015L152.86 109.552Z",
    fill: "#263238"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M157.687 109.661C157.597 115.89 162.619 121.011 168.904 121.101C175.19 121.191 180.36 116.215 180.45 109.987C180.541 103.759 175.519 98.6367 169.233 98.5471C162.947 98.457 157.778 103.433 157.687 109.661Z",
    fill: "#FAFAFA"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M169.233 98.5471C162.947 98.4572 157.778 103.433 157.687 109.662L180.45 109.987C180.541 103.759 175.519 98.637 169.233 98.5471Z",
    fill: "#E0E0E0"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M162.136 109.725C162.08 113.519 165.14 116.639 168.968 116.694C172.797 116.749 175.947 113.717 176.002 109.924C176.057 106.129 172.997 103.01 169.168 102.955C165.34 102.9 162.191 105.931 162.136 109.725Z",
    fill: "#263238"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1064 99.6083C69.1041 99.6092 69.0858 99.5717 69.0529 99.4983C69.018 99.4179 68.9704 99.3091 68.9099 99.17C68.7716 98.8874 68.5771 98.4649 68.2594 97.958C67.64 96.9382 66.5366 95.5725 64.8685 94.2221C63.2091 92.8702 60.9997 91.5135 58.3212 90.5605C55.6497 89.6072 52.5018 89.0937 49.226 89.3229C45.9505 89.558 42.8961 90.4545 40.3502 91.7027C37.7909 92.9411 35.7321 94.5015 34.1694 95.9628C33.3884 96.6972 32.7367 97.4155 32.1813 98.0597C31.9144 98.3906 31.6601 98.6945 31.4404 98.9851C31.2256 99.2791 31.0198 99.5412 30.8506 99.7883C30.6823 100.035 30.5323 100.254 30.4015 100.445C30.2792 100.638 30.1748 100.802 30.0891 100.937C30.0071 101.066 29.9429 101.166 29.8955 101.24C29.851 101.307 29.8272 101.341 29.8251 101.34C29.8228 101.339 29.8423 101.302 29.8821 101.232C29.9263 101.156 29.9862 101.053 30.0629 100.922C30.144 100.786 30.2408 100.616 30.3635 100.421C30.4911 100.227 30.6376 100.005 30.8018 99.7552C30.9675 99.5052 31.1701 99.2397 31.3822 98.9422C31.5991 98.6484 31.8508 98.3408 32.1156 98.0064C32.6664 97.3547 33.3155 96.6286 34.095 95.8862C35.6547 94.4087 37.7176 92.8314 40.2883 91.5789C42.8464 90.3165 45.9176 89.4102 49.2149 89.1735C52.5131 88.9425 55.6823 89.4641 58.368 90.4306C61.0608 91.3968 63.2774 92.7712 64.9362 94.1406C66.6046 95.5086 67.7028 96.8939 68.3094 97.9281C68.9215 98.9643 69.1064 99.6083 69.1064 99.6083Z",
    fill: "#263238"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M188.974 98.1047C188.971 98.1055 188.953 98.0684 188.92 97.9944C188.885 97.914 188.837 97.8052 188.777 97.666C188.639 97.3835 188.444 96.961 188.126 96.4541C187.507 95.4343 186.404 94.0686 184.735 92.7182C183.076 91.3663 180.867 90.0096 178.188 89.0566C175.517 88.1033 172.369 87.5898 169.093 87.819C165.817 88.054 162.763 88.9506 160.217 90.1988C157.658 91.4372 155.599 92.9976 154.036 94.4589C153.255 95.1933 152.604 95.9115 152.048 96.5558C151.781 96.8867 151.527 97.1906 151.307 97.4809C151.093 97.7749 150.887 98.037 150.718 98.2841C150.549 98.5303 150.399 98.7495 150.268 98.941C150.146 99.1337 150.042 99.2979 149.956 99.4332C149.874 99.5614 149.81 99.6613 149.762 99.7353C149.718 99.803 149.694 99.837 149.692 99.8358C149.69 99.8347 149.709 99.7978 149.749 99.7278C149.793 99.6518 149.853 99.5493 149.93 99.4177C150.011 99.2823 150.108 99.1124 150.23 98.9171C150.358 98.7233 150.504 98.501 150.669 98.2513C150.834 98.0013 151.037 97.7357 151.249 97.4382C151.466 97.1445 151.718 96.8369 151.983 96.5025C152.533 95.8508 153.182 95.1247 153.962 94.3823C155.522 92.9048 157.585 91.3275 160.155 90.0749C162.713 88.8126 165.785 87.9063 169.082 87.6696C172.38 87.4386 175.549 87.9602 178.235 88.9267C180.928 89.8929 183.144 91.2673 184.803 92.6367C186.472 94.0047 187.57 95.39 188.176 96.4245C188.789 97.461 188.974 98.1047 188.974 98.1047Z",
    fill: "#263238"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M148.696 101.644C148.698 101.686 131.628 102.551 110.574 103.577C89.5124 104.604 72.443 105.402 72.4409 105.36C72.4389 105.319 89.5051 104.454 110.567 103.427C131.62 102.401 148.694 101.603 148.696 101.644Z",
    fill: "#263238"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9866 77.4078L65.8721 77.2549L65.0077 77.8162L60.9866 77.4078Z",
    fill: "#263238"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3892 78.989C78.4153 79.0579 77.4009 81.2723 77.4009 81.2723L78.1572 81.9733H81.8417C81.8417 81.9733 84.7454 78.9058 84.6478 78.989C84.5501 79.072 78.5476 78.9873 78.5476 78.9873",
    fill: "#0F538D"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.415 78.989C78.4412 79.0579 77.4268 81.2723 77.4268 81.2723L78.1831 81.9733H81.8676C81.8676 81.9733 84.7713 78.9058 84.6737 78.989C84.576 79.072 78.5734 78.9873 78.5734 78.9873",
    fill: "black"
  }))), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6105 76.5456C77.5486 76.6683 78.1274 78.2333 78.4907 79.188C78.6584 79.6286 79.0834 79.9189 79.5589 79.9189H86.4224L86.7029 75.1171L84.42 72.8154C84.42 72.8154 78.4517 74.8787 77.6105 76.5456Z",
    fill: "#0F538D"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6105 76.5457C77.6105 76.5457 77.6794 76.3504 77.9375 76.0751C78.1933 75.8004 78.6273 75.4571 79.2194 75.095C80.4047 74.3704 82.2013 73.5436 84.397 72.751L84.4377 72.7363L84.4688 72.7674C85.1754 73.4774 85.948 74.2535 86.7558 75.0651L86.779 75.0884L86.777 75.1213C86.7328 75.8819 86.6872 76.6739 86.6404 77.4826C86.5913 78.3186 86.543 79.1366 86.4965 79.9231L86.4924 79.9928H86.4221C84.849 79.9896 83.3716 79.9864 82.0377 79.9839C81.3724 79.9813 80.7431 79.9787 80.1559 79.9764C80.0094 79.9755 79.8655 79.9749 79.7243 79.9743C79.5862 79.9738 79.4385 79.9769 79.2996 79.9438C79.022 79.8819 78.7848 79.7223 78.6261 79.5219C78.4607 79.3174 78.4078 79.0784 78.3267 78.8782C78.252 78.6717 78.1814 78.477 78.1154 78.2944C77.9858 77.9301 77.8782 77.6162 77.796 77.3584C77.6268 76.8458 77.5748 76.546 77.6105 76.5457C77.594 76.5474 77.6614 76.8337 77.8463 77.3417C77.941 77.5992 78.0553 77.9094 78.1872 78.2685C78.2564 78.4497 78.3302 78.6429 78.4084 78.848C78.4942 79.0519 78.5503 79.282 78.7023 79.4617C78.8505 79.6437 79.0691 79.7869 79.3226 79.8401C79.4487 79.8687 79.5807 79.8649 79.7243 79.8638C79.8655 79.8632 80.0094 79.8623 80.1559 79.8617C80.7431 79.8594 81.3724 79.8568 82.0377 79.8542C83.3713 79.8514 84.849 79.8485 86.4221 79.845L86.348 79.9144C86.3936 79.1279 86.4407 78.3097 86.4892 77.4736C86.5369 76.6649 86.5834 75.8729 86.6282 75.1123L86.6494 75.1682C85.8443 74.3537 85.0746 73.5747 84.3706 72.8625L84.4421 72.8789C82.2516 73.6571 80.4509 74.4649 79.2621 75.1645C78.6677 75.5141 78.2311 75.8433 77.9689 76.1048C77.7053 76.3666 77.6219 76.5523 77.6105 76.5457Z",
    fill: "#263238"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6263 75.0693C86.6286 75.0794 86.5045 75.1154 86.2783 75.1713C86.0522 75.2277 85.7235 75.3026 85.3165 75.3904C84.5021 75.5661 83.3725 75.7882 82.1192 76.0007C80.8653 76.213 79.7253 76.376 78.8986 76.4785C78.485 76.5298 78.1501 76.5675 77.9179 76.5888C77.6857 76.6104 77.5569 76.6176 77.5554 76.6072C77.554 76.5969 77.6804 76.5704 77.91 76.5309C78.1705 76.4889 78.4963 76.4362 78.8835 76.3737C79.7058 76.2444 80.8414 76.0652 82.0936 75.853C83.3452 75.6404 84.4765 75.4354 85.2953 75.2865C85.6813 75.2179 86.0063 75.1603 86.2661 75.1142C86.496 75.0756 86.6242 75.0592 86.6263 75.0693Z",
    fill: "#263238"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3473 79.8668C79.3842 79.8861 79.1572 80.3863 78.8398 80.9839C78.5224 81.5818 78.2352 82.0507 78.1983 82.0314C78.1614 82.0121 78.3884 81.5118 78.7058 80.914C79.0229 80.3164 79.3104 79.8475 79.3473 79.8668Z",
    fill: "#263238"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M117.876 79.4236C117.878 79.4651 111.454 79.8412 103.529 80.2637C95.6006 80.6865 89.174 80.9956 89.1716 80.9541C89.1693 80.9126 95.5925 80.5368 103.52 80.114C111.445 79.6915 117.874 79.3822 117.876 79.4236Z",
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M148.8 77.7531C148.803 77.7945 142.899 78.1407 135.615 78.5266C128.329 78.9125 122.422 79.1919 122.42 79.1504C122.418 79.1092 128.321 78.7628 135.607 78.3769C142.891 77.9912 148.798 77.7119 148.8 77.7531Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M112.973 58.0907C112.974 58.0958 112.918 58.1062 112.813 58.1215C112.69 58.137 112.537 58.1566 112.35 58.1805C111.927 58.2301 111.351 58.2977 110.647 58.3801C109.21 58.5486 107.226 58.7934 105.04 59.1044C102.854 59.4163 100.88 59.7351 99.453 59.9748C98.7551 60.092 98.1828 60.1879 97.7628 60.2584C97.5765 60.2878 97.4242 60.3117 97.3024 60.3307C97.1969 60.3457 97.1408 60.3512 97.1399 60.346C97.139 60.3408 97.1928 60.3255 97.2969 60.3011C97.4175 60.2746 97.5681 60.2414 97.7523 60.2008C98.1482 60.1165 98.7232 60.003 99.4347 59.8699C100.858 59.6032 102.831 59.2677 105.019 58.9555C107.207 58.6442 109.195 58.4158 110.636 58.2744C111.357 58.2036 111.941 58.1517 112.345 58.1221C112.533 58.1094 112.687 58.0993 112.81 58.091C112.916 58.0858 112.973 58.0855 112.973 58.0907Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2228 74.5436C82.2359 74.5857 81.4726 74.8446 80.5637 75.238C79.653 75.6288 78.9417 76.0052 78.9196 75.9672C78.899 75.9341 79.5832 75.4955 80.5035 75.1006C81.4217 74.7029 82.2123 74.5059 82.2228 74.5436Z",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7508 78.1509C56.7511 78.1535 56.7255 78.1593 56.6752 78.1682C56.6162 78.1777 56.5424 78.1895 56.4511 78.2039C56.2421 78.2336 55.9538 78.2748 55.5878 78.3269C54.8376 78.4283 53.7532 78.5832 52.4149 78.7851C49.7385 79.1874 46.0508 79.8104 42.0099 80.6571C37.9682 81.507 34.3421 82.4197 31.7308 83.1273C30.4251 83.4804 29.3703 83.7744 28.6433 83.9832C28.2878 84.0826 28.0074 84.1609 27.8042 84.2177C27.7149 84.241 27.6429 84.26 27.5847 84.275C27.535 84.2871 27.5091 84.2923 27.5086 84.2897C27.5077 84.2871 27.5321 84.2773 27.5804 84.2603C27.637 84.2413 27.708 84.2179 27.7955 84.1886C27.9966 84.1252 28.2745 84.0379 28.6268 83.9271C29.3491 83.701 30.3995 83.3914 31.7026 83.0248C34.3081 82.2904 37.9336 81.3607 41.9788 80.5099C46.0235 79.6624 49.7175 79.0555 52.3995 78.6797C53.7407 78.4911 54.8277 78.352 55.5806 78.2684C55.948 78.2281 56.2378 78.1964 56.4476 78.1734C56.5395 78.1648 56.6139 78.1581 56.6735 78.1524C56.7241 78.1492 56.7505 78.1483 56.7508 78.1509Z",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6759 90.1078C52.6756 90.113 52.6096 90.1173 52.4844 90.121C52.3434 90.1233 52.1614 90.1259 51.9362 90.1297C51.6981 90.1291 51.4074 90.1323 51.07 90.1544C50.7328 90.174 50.348 90.1804 49.9256 90.2284C49.7137 90.2483 49.4922 90.2691 49.2617 90.2904C49.031 90.3128 48.7929 90.3534 48.5455 90.3857C48.0494 90.4442 47.5262 90.5504 46.9742 90.6518C45.8761 90.8831 44.6814 91.1979 43.4592 91.6258C42.2404 92.0642 41.1152 92.5725 40.1185 93.0848C39.627 93.3538 39.1547 93.6006 38.7338 93.8676C38.5219 93.9984 38.312 94.117 38.1193 94.2446C37.9275 94.3731 37.7432 94.4963 37.5665 94.6144C37.209 94.8428 36.9078 95.0801 36.6349 95.2771C36.3602 95.4721 36.1332 95.6526 35.9501 95.8027C35.7737 95.9418 35.6315 96.0538 35.5211 96.1408C35.4219 96.2168 35.3682 96.2551 35.3647 96.2511C35.3612 96.2474 35.4083 96.2016 35.5013 96.1181C35.6071 96.0253 35.7434 95.9058 35.9126 95.7578C36.0905 95.6002 36.3125 95.4127 36.5834 95.2106C36.8526 95.0067 37.1505 94.7624 37.5054 94.5274C37.681 94.4062 37.8644 94.2797 38.0551 94.1478C38.2469 94.0171 38.4562 93.8956 38.6678 93.7616C39.0881 93.4889 39.5605 93.2363 40.0531 92.9627C41.0519 92.4409 42.182 91.9256 43.4083 91.4847C44.6375 91.0541 45.8409 90.7414 46.9466 90.5164C47.5023 90.418 48.029 90.316 48.5287 90.2624C48.7778 90.2328 49.0176 90.1948 49.2495 90.1752C49.4815 90.1567 49.7041 90.1392 49.9175 90.1225C50.3424 90.0807 50.729 90.0819 51.0677 90.0703C51.4063 90.0559 51.6981 90.0614 51.9368 90.0709C52.1623 90.079 52.3443 90.0856 52.4855 90.0905C52.6105 90.0968 52.6762 90.1026 52.6759 90.1078Z",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M171.032 88.5555C171.032 88.5607 170.966 88.5679 170.84 88.5771C170.699 88.5855 170.516 88.5961 170.289 88.6094C170.05 88.6189 169.758 88.6347 169.42 88.6722C169.082 88.707 168.695 88.73 168.273 88.798C168.061 88.8277 167.839 88.8585 167.608 88.8907C167.377 88.9242 167.14 88.976 166.893 89.0201C166.397 89.1021 165.876 89.234 165.326 89.3628C164.234 89.6488 163.049 90.0252 161.844 90.5185C160.642 91.0225 159.539 91.5942 158.567 92.1642C158.088 92.4619 157.627 92.7364 157.22 93.0287C157.015 93.1722 156.811 93.3032 156.625 93.4426C156.439 93.5826 156.262 93.7173 156.091 93.8464C155.746 94.0966 155.458 94.353 155.195 94.5672C154.931 94.7795 154.714 94.9745 154.539 95.1366C154.371 95.2869 154.235 95.4085 154.13 95.5024C154.034 95.5847 153.983 95.6265 153.979 95.6227C153.975 95.619 154.02 95.5703 154.108 95.4808C154.209 95.3814 154.338 95.253 154.499 95.094C154.668 94.9249 154.879 94.723 155.14 94.5042C155.398 94.2833 155.682 94.02 156.025 93.7634C156.194 93.6315 156.371 93.4936 156.555 93.3501C156.74 93.2076 156.943 93.0737 157.148 92.9271C157.554 92.6287 158.015 92.3488 158.494 92.0461C159.468 91.4663 160.576 90.8875 161.785 90.3803C162.998 89.8838 164.191 89.5091 165.292 89.2289C165.846 89.1033 166.37 88.9748 166.87 88.8979C167.119 88.8562 167.358 88.8069 167.59 88.7764C167.823 88.7473 168.046 88.7194 168.259 88.6929C168.685 88.6313 169.074 88.6154 169.413 88.5886C169.753 88.559 170.047 88.5515 170.287 88.5509C170.514 88.5492 170.698 88.5477 170.84 88.5469C170.966 88.5475 171.032 88.5503 171.032 88.5555Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.145 85.33C116.145 86.3389 114.637 87.1568 112.777 87.1568C110.917 87.1568 109.409 86.3389 109.409 85.33C109.409 84.3211 110.917 83.5029 112.777 83.5029C114.637 83.5029 116.145 84.3208 116.145 85.33Z",
    fill: "black"
  }))), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M116.704 86.2252H108.85C108.352 86.2252 107.947 85.8246 107.947 85.3304C107.947 84.8362 108.352 84.4355 108.85 84.4355H116.704C117.203 84.4355 117.607 84.8362 117.607 85.3304C117.607 85.8246 117.203 86.2252 116.704 86.2252Z",
    fill: "#0F538D"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M116.704 86.225C116.704 86.2169 116.78 86.2198 116.915 86.1838C117.048 86.1475 117.249 86.0591 117.404 85.8468C117.56 85.6443 117.643 85.2895 117.478 84.9586C117.398 84.7962 117.255 84.6482 117.066 84.5638C116.879 84.4687 116.654 84.4872 116.409 84.4886C114.46 84.4944 111.795 84.5021 108.851 84.5105C108.509 84.5053 108.189 84.7331 108.076 85.0413C107.956 85.3477 108.045 85.7126 108.282 85.9275C108.398 86.0369 108.545 86.1098 108.699 86.1383C108.849 86.163 109.028 86.1492 109.193 86.1535C109.527 86.1544 109.855 86.1553 110.175 86.1561C111.45 86.1622 112.6 86.1676 113.573 86.1723C114.528 86.182 115.306 86.1904 115.864 86.1962C116.123 86.2019 116.33 86.2068 116.487 86.2103C116.629 86.2146 116.704 86.2198 116.704 86.225C116.704 86.2301 116.629 86.235 116.487 86.2399C116.33 86.2434 116.123 86.2483 115.864 86.254C115.307 86.2598 114.528 86.2679 113.573 86.2779C112.6 86.2826 111.451 86.288 110.175 86.2941C109.855 86.2949 109.527 86.2958 109.193 86.2967C109.024 86.2921 108.862 86.3096 108.673 86.2811C108.491 86.2483 108.317 86.1627 108.181 86.0346C107.901 85.782 107.793 85.3512 107.935 84.9886C108.068 84.624 108.446 84.3547 108.851 84.3604C111.795 84.3691 114.46 84.3769 116.409 84.3823C116.531 84.3846 116.645 84.3809 116.766 84.3881C116.888 84.3967 117.003 84.4284 117.107 84.4774C117.315 84.575 117.469 84.7418 117.554 84.922C117.728 85.2898 117.625 85.6711 117.451 85.8817C117.277 86.1026 117.061 86.1849 116.922 86.2132C116.78 86.2405 116.704 86.225 116.704 86.225Z",
    fill: "#263238"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M115.913 84.6247C115.913 84.6662 114.384 84.6996 112.498 84.6996C110.612 84.6996 109.083 84.6659 109.083 84.6247C109.083 84.5832 110.612 84.5498 112.498 84.5498C114.384 84.5498 115.913 84.5835 115.913 84.6247Z",
    fill: "white"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.89 85.33C157.89 86.3389 156.382 87.1568 154.522 87.1568C152.662 87.1568 151.155 86.3389 151.155 85.33C151.155 84.3211 152.662 83.5029 154.522 83.5029C156.382 83.5029 157.89 84.3208 157.89 85.33Z",
    fill: "black"
  }))), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M158.449 86.2252H150.596C150.097 86.2252 149.692 85.8246 149.692 85.3304C149.692 84.8362 150.097 84.4355 150.596 84.4355H158.449C158.948 84.4355 159.352 84.8362 159.352 85.3304C159.352 85.8246 158.948 86.2252 158.449 86.2252Z",
    fill: "#0F538D"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M158.449 86.225C158.449 86.2169 158.525 86.2198 158.661 86.1838C158.793 86.1475 158.994 86.0591 159.149 85.8468C159.306 85.6443 159.388 85.2895 159.223 84.9586C159.143 84.7962 159 84.6482 158.811 84.5638C158.624 84.4687 158.399 84.4872 158.154 84.4886C156.205 84.4944 153.54 84.5021 150.596 84.5105C150.254 84.5053 149.934 84.7331 149.821 85.0413C149.701 85.3477 149.791 85.7126 150.027 85.9275C150.143 86.0369 150.29 86.1098 150.445 86.1383C150.594 86.163 150.773 86.1492 150.938 86.1535C151.272 86.1544 151.6 86.1553 151.92 86.1561C153.195 86.1622 154.346 86.1676 155.318 86.1723C156.273 86.182 157.051 86.1904 157.609 86.1962C157.868 86.2019 158.075 86.2068 158.232 86.2103C158.375 86.2146 158.449 86.2198 158.449 86.225C158.449 86.2301 158.375 86.235 158.232 86.2399C158.075 86.2434 157.868 86.2483 157.609 86.254C157.052 86.2598 156.273 86.2679 155.318 86.2779C154.346 86.2826 153.196 86.288 151.92 86.2941C151.6 86.2949 151.272 86.2958 150.938 86.2967C150.769 86.2921 150.607 86.3096 150.418 86.2811C150.236 86.2483 150.062 86.1627 149.926 86.0346C149.646 85.782 149.539 85.3512 149.68 84.9886C149.813 84.624 150.191 84.3547 150.596 84.3604C153.54 84.3691 156.205 84.3769 158.154 84.3823C158.277 84.3846 158.39 84.3809 158.511 84.3881C158.633 84.3967 158.748 84.4284 158.852 84.4774C159.06 84.575 159.215 84.7418 159.299 84.922C159.473 85.2898 159.37 85.6711 159.196 85.8817C159.022 86.1026 158.806 86.1849 158.668 86.2132C158.525 86.2405 158.449 86.225 158.449 86.225Z",
    fill: "#263238"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M158.811 84.7057C158.811 84.7472 156.87 84.7806 154.476 84.7806C152.082 84.7806 150.141 84.7469 150.141 84.7057C150.141 84.6643 152.082 84.6309 154.476 84.6309C156.869 84.6306 158.811 84.6643 158.811 84.7057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDetailsCar);
export default __webpack_public_path__ + "static/media/companyDetailsCar.f28bcd4d12694465e0a6be4a0eb77844.svg";
export { ForwardRef as ReactComponent };